import {StyleProp, TextStyle, ViewStyle} from 'react-native'
import Svg, {Path, Rect, Line, Ellipse, Polyline} from 'react-native-svg'

import React from 'react'

export function NFTDropDownIconDark({
  style,
  size,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      width={size || 500}
      height={size || 500}
      style={style}
      viewBox="0 0 375 374.999991"
      preserveAspectRatio="xMidYMid meet">
      <defs>
        <g />
        <clipPath id="fcea76f8fe">
          <path
            d="M 26.261719 4.273438 L 348.730469 4.273438 L 348.730469 370.726562 L 26.261719 370.726562 Z M 26.261719 4.273438 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="ebaf29560e">
          <path
            d="M 37.363281 13.601562 L 337.5 13.601562 L 337.5 361.804688 L 37.363281 361.804688 Z M 37.363281 13.601562 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="6f9da69996">
          <path
            d="M 187.433594 13.601562 L 337.5 98.332031 L 337.5 276.667969 L 187.433594 361.398438 L 37.363281 276.667969 L 37.363281 98.332031 Z M 187.433594 13.601562 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#fcea76f8fe)">
        <path
          fill="#000000"
          d="M 187.492188 17.609375 C 186.515625 17.609375 185.535156 17.863281 184.660156 18.371094 L 42.4375 100.480469 C 40.691406 101.492188 39.605469 103.371094 39.605469 105.390625 L 39.605469 269.613281 C 39.605469 271.632812 40.691406 273.511719 42.4375 274.519531 L 184.660156 356.632812 C 186.40625 357.640625 188.578125 357.640625 190.328125 356.632812 L 332.550781 274.519531 C 334.296875 273.511719 335.386719 271.632812 335.386719 269.613281 L 335.386719 105.390625 C 335.386719 103.371094 334.296875 101.492188 332.550781 100.480469 L 190.328125 18.371094 C 189.453125 17.863281 188.472656 17.609375 187.492188 17.609375 Z M 187.492188 370.726562 C 184.207031 370.726562 180.921875 369.882812 177.988281 368.191406 L 35.765625 286.074219 C 29.902344 282.691406 26.261719 276.382812 26.261719 269.613281 L 26.261719 105.390625 C 26.261719 98.621094 29.902344 92.308594 35.765625 88.925781 L 177.988281 6.8125 C 183.851562 3.425781 191.136719 3.425781 197 6.8125 L 339.222656 88.925781 C 345.085938 92.308594 348.730469 98.621094 348.730469 105.390625 L 348.730469 269.613281 C 348.730469 276.382812 345.085938 282.691406 339.222656 286.078125 L 197 368.191406 C 194.070312 369.882812 190.78125 370.726562 187.492188 370.726562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#ebaf29560e)">
        <g clipPath="url(#6f9da69996)">
          <path
            fill="#ffffff"
            d="M 37.363281 13.601562 L 337.5 13.601562 L 337.5 361.804688 L 37.363281 361.804688 Z M 37.363281 13.601562 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g fill="#000000" fillOpacity="1">
        <g transform="translate(44.709956, 237.468535)">
          <g>
            <path d="M 71.375 0 L 27.328125 -77.828125 C 28.191406 -70.273438 28.625 -64.203125 28.625 -59.609375 L 28.625 0 L 9.828125 0 L 9.828125 -101.0625 L 34 -101.0625 L 78.6875 -22.59375 C 77.820312 -29.8125 77.390625 -36.390625 77.390625 -42.328125 L 77.390625 -101.0625 L 96.1875 -101.0625 L 96.1875 0 Z M 71.375 0 " />
          </g>
        </g>
        <g transform="translate(150.801854, 237.468535)">
          <g>
            <path d="M 30.984375 -84.71875 L 30.984375 -53.4375 L 82.703125 -53.4375 L 82.703125 -37.078125 L 30.984375 -37.078125 L 30.984375 0 L 9.828125 0 L 9.828125 -101.0625 L 84.359375 -101.0625 L 84.359375 -84.71875 Z M 30.984375 -84.71875 " />
          </g>
        </g>
        <g transform="translate(240.538814, 237.468535)">
          <g>
            <path d="M 55.453125 -84.71875 L 55.453125 0 L 34.28125 0 L 34.28125 -84.71875 L 1.65625 -84.71875 L 1.65625 -101.0625 L 88.15625 -101.0625 L 88.15625 -84.71875 Z M 55.453125 -84.71875 " />
          </g>
        </g>
      </g>
    </Svg>
  )
}

export function NFTDropDownIcon({
  style,
  size,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      width={size || 500}
      height={size || 500}
      viewBox="0 0 375 374.999991"
      preserveAspectRatio="xMidYMid meet"
      style={style}>
      <defs>
        <g />
        <clipPath id="3bf4ebae58">
          <path
            d="M 26.261719 4.273438 L 348.730469 4.273438 L 348.730469 370.726562 L 26.261719 370.726562 Z M 26.261719 4.273438 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="a0f8c5cfe6">
          <path
            d="M 31.769531 10.191406 L 342.898438 10.191406 L 342.898438 371 L 31.769531 371 Z M 31.769531 10.191406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="9f5a6851d2">
          <path
            d="M 187.335938 10.191406 L 342.898438 98.023438 L 342.898438 282.894531 L 187.335938 370.726562 L 31.769531 282.894531 L 31.769531 98.023438 Z M 187.335938 10.191406 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#3bf4ebae58)">
        <path
          fill="#452996"
          d="M 187.492188 17.609375 C 186.515625 17.609375 185.535156 17.863281 184.660156 18.371094 L 42.4375 100.480469 C 40.691406 101.492188 39.605469 103.371094 39.605469 105.390625 L 39.605469 269.613281 C 39.605469 271.632812 40.691406 273.511719 42.4375 274.519531 L 184.660156 356.632812 C 186.40625 357.640625 188.578125 357.640625 190.328125 356.632812 L 332.550781 274.519531 C 334.296875 273.511719 335.386719 271.632812 335.386719 269.613281 L 335.386719 105.390625 C 335.386719 103.371094 334.296875 101.492188 332.550781 100.480469 L 190.328125 18.371094 C 189.453125 17.863281 188.472656 17.609375 187.492188 17.609375 Z M 187.492188 370.726562 C 184.207031 370.726562 180.921875 369.882812 177.988281 368.191406 L 35.765625 286.074219 C 29.902344 282.691406 26.261719 276.382812 26.261719 269.613281 L 26.261719 105.390625 C 26.261719 98.621094 29.902344 92.308594 35.765625 88.925781 L 177.988281 6.8125 C 183.851562 3.425781 191.136719 3.425781 197 6.8125 L 339.222656 88.925781 C 345.085938 92.308594 348.730469 98.621094 348.730469 105.390625 L 348.730469 269.613281 C 348.730469 276.382812 345.085938 282.691406 339.222656 286.078125 L 197 368.191406 C 194.070312 369.882812 190.78125 370.726562 187.492188 370.726562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#a0f8c5cfe6)">
        <g clipPath="url(#9f5a6851d2)">
          <path
            fill="#452996"
            d="M 31.769531 10.191406 L 342.898438 10.191406 L 342.898438 371.148438 L 31.769531 371.148438 Z M 31.769531 10.191406 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g fill="#ffffff" fillOpacity="1">
        <g transform="translate(44.709956, 237.468535)">
          <g>
            <path d="M 71.375 0 L 27.328125 -77.828125 C 28.191406 -70.273438 28.625 -64.203125 28.625 -59.609375 L 28.625 0 L 9.828125 0 L 9.828125 -101.0625 L 34 -101.0625 L 78.6875 -22.59375 C 77.820312 -29.8125 77.390625 -36.390625 77.390625 -42.328125 L 77.390625 -101.0625 L 96.1875 -101.0625 L 96.1875 0 Z M 71.375 0 " />
          </g>
        </g>
        <g transform="translate(150.801854, 237.468535)">
          <g>
            <path d="M 30.984375 -84.71875 L 30.984375 -53.4375 L 82.703125 -53.4375 L 82.703125 -37.078125 L 30.984375 -37.078125 L 30.984375 0 L 9.828125 0 L 9.828125 -101.0625 L 84.359375 -101.0625 L 84.359375 -84.71875 Z M 30.984375 -84.71875 " />
          </g>
        </g>
        <g transform="translate(240.538814, 237.468535)">
          <g>
            <path d="M 55.453125 -84.71875 L 55.453125 0 L 34.28125 0 L 34.28125 -84.71875 L 1.65625 -84.71875 L 1.65625 -101.0625 L 88.15625 -101.0625 L 88.15625 -84.71875 Z M 55.453125 -84.71875 " />
          </g>
        </g>
      </g>
    </Svg>
  )
}

export function ChannelDropDownIcon({
  style,
  size,
  strokeWidth = 2,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      width={size || 24}
      height={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}>
      <Path d="m6 9 6 6 6-6" />
    </Svg>
  )
}

export function DownloadIcon({
  size = 24,
  style,
}: {
  size?: number
  style?: StyleProp<ViewStyle>
}) {
  return (
    <Svg
      width={size}
      height={size}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <Path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <Polyline points="7 10 12 15 17 10" />
      <Line x1="12" x2="12" y1="15" y2="3" />
    </Svg>
  )
}

export function UploadIcon({
  size = 24,
  style,
}: {
  size?: number
  style?: StyleProp<ViewStyle>
}) {
  return (
    <Svg
      width={size}
      height={size}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <Path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <Polyline points="17 8 12 3 7 8" />
      <Line x1="12" x2="12" y1="3" y2="15" />
    </Svg>
  )
}

export function VideoNftIconLight({
  size = 24,
}: {
  style?: StyleProp<ViewStyle>
  size?: number
  fill?: string
}) {
  return (
    <svg
      width={size}
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height={size}
      preserveAspectRatio="xMidYMid meet"
      version="1.0">
      <defs>
        <g />
        <clipPath id="3c77122ae9">
          <path
            d="M 31.933594 7.230469 L 343.066406 7.230469 L 343.066406 368 L 31.933594 368 Z M 31.933594 7.230469 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="7e633584e4">
          <path
            d="M 187.5 7.230469 L 343.066406 95.066406 L 343.066406 279.933594 L 187.5 367.769531 L 31.933594 279.933594 L 31.933594 95.066406 Z M 187.5 7.230469 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="03ca8736c7">
          <path
            d="M 26.261719 4.273438 L 348.730469 4.273438 L 348.730469 370.726562 L 26.261719 370.726562 Z M 26.261719 4.273438 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="ffc739695e">
          <path
            d="M 112.5 77.089844 L 262.5 77.089844 L 262.5 170.089844 L 112.5 170.089844 Z M 112.5 77.089844 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#3c77122ae9)">
        <g clipPath="url(#7e633584e4)">
          <path
            fill="#452996"
            d="M 31.933594 7.230469 L 343.066406 7.230469 L 343.066406 368.191406 L 31.933594 368.191406 Z M 31.933594 7.230469 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g clipPath="url(#03ca8736c7)">
        <path
          fill="#452996"
          d="M 187.492188 17.609375 C 186.515625 17.609375 185.535156 17.863281 184.660156 18.371094 L 42.4375 100.480469 C 40.691406 101.492188 39.605469 103.371094 39.605469 105.390625 L 39.605469 269.613281 C 39.605469 271.632812 40.691406 273.511719 42.4375 274.519531 L 184.660156 356.632812 C 186.40625 357.640625 188.578125 357.640625 190.328125 356.632812 L 332.550781 274.519531 C 334.296875 273.511719 335.386719 271.632812 335.386719 269.613281 L 335.386719 105.390625 C 335.386719 103.371094 334.296875 101.492188 332.550781 100.480469 L 190.328125 18.371094 C 189.453125 17.863281 188.472656 17.609375 187.492188 17.609375 Z M 187.492188 370.726562 C 184.207031 370.726562 180.921875 369.882812 177.988281 368.191406 L 35.765625 286.074219 C 29.902344 282.691406 26.261719 276.382812 26.261719 269.613281 L 26.261719 105.390625 C 26.261719 98.621094 29.902344 92.308594 35.765625 88.925781 L 177.988281 6.8125 C 183.851562 3.425781 191.136719 3.425781 197 6.8125 L 339.222656 88.925781 C 345.085938 92.308594 348.730469 98.621094 348.730469 105.390625 L 348.730469 269.613281 C 348.730469 276.382812 345.085938 282.691406 339.222656 286.078125 L 197 368.191406 C 194.070312 369.882812 190.78125 370.726562 187.492188 370.726562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#ffc739695e)">
        <path
          fill="#ffffff"
          d="M 126.960938 170.226562 L 212.683594 170.226562 C 213.613281 170.222656 214.535156 170.132812 215.445312 169.949219 C 216.359375 169.769531 217.242188 169.5 218.101562 169.140625 C 218.960938 168.785156 219.777344 168.347656 220.550781 167.832031 C 221.324219 167.316406 222.039062 166.726562 222.695312 166.070312 C 223.355469 165.414062 223.941406 164.699219 224.460938 163.925781 C 224.976562 163.152344 225.414062 162.335938 225.769531 161.476562 C 226.125 160.617188 226.394531 159.730469 226.578125 158.820312 C 226.757812 157.90625 226.851562 156.988281 226.851562 156.054688 L 226.851562 146.367188 L 248.554688 158.117188 C 248.902344 158.304688 249.265625 158.472656 249.636719 158.613281 C 250.011719 158.757812 250.390625 158.875 250.777344 158.972656 C 251.167969 159.066406 251.558594 159.132812 251.953125 159.175781 C 252.351562 159.21875 252.75 159.238281 253.148438 159.230469 C 253.546875 159.222656 253.945312 159.1875 254.339844 159.128906 C 254.734375 159.066406 255.121094 158.984375 255.503906 158.875 C 255.890625 158.761719 256.265625 158.628906 256.628906 158.472656 C 256.996094 158.3125 257.351562 158.132812 257.691406 157.925781 C 258.035156 157.722656 258.363281 157.496094 258.675781 157.25 C 258.992188 157.003906 259.289062 156.738281 259.566406 156.453125 C 259.847656 156.167969 260.105469 155.867188 260.347656 155.546875 C 260.585938 155.230469 260.804688 154.894531 261 154.550781 C 261.199219 154.203125 261.371094 153.84375 261.523438 153.476562 C 261.675781 153.105469 261.800781 152.726562 261.902344 152.34375 C 262.003906 151.957031 262.082031 151.566406 262.132812 151.171875 C 262.183594 150.773438 262.210938 150.378906 262.210938 149.976562 L 262.210938 97.457031 C 262.210938 97.058594 262.183594 96.660156 262.132812 96.265625 C 262.082031 95.867188 262.003906 95.476562 261.902344 95.09375 C 261.800781 94.707031 261.675781 94.328125 261.523438 93.960938 C 261.371094 93.589844 261.199219 93.230469 261 92.886719 C 260.804688 92.539062 260.585938 92.207031 260.347656 91.886719 C 260.105469 91.566406 259.847656 91.265625 259.566406 90.980469 C 259.289062 90.695312 258.992188 90.429688 258.675781 90.183594 C 258.363281 89.9375 258.035156 89.710938 257.691406 89.507812 C 257.351562 89.304688 256.996094 89.121094 256.628906 88.964844 C 256.265625 88.804688 255.890625 88.671875 255.503906 88.5625 C 255.121094 88.449219 254.734375 88.367188 254.339844 88.308594 C 253.945312 88.246094 253.546875 88.214844 253.148438 88.207031 C 252.75 88.195312 252.351562 88.214844 251.953125 88.257812 C 251.558594 88.300781 251.167969 88.371094 250.777344 88.464844 C 250.390625 88.558594 250.011719 88.675781 249.636719 88.820312 C 249.265625 88.960938 248.902344 89.128906 248.554688 89.320312 L 226.851562 101.066406 L 226.851562 91.378906 C 226.851562 90.449219 226.757812 89.527344 226.578125 88.613281 C 226.394531 87.703125 226.125 86.816406 225.769531 85.957031 C 225.414062 85.097656 224.976562 84.28125 224.460938 83.511719 C 223.941406 82.738281 223.355469 82.019531 222.695312 81.363281 C 222.039062 80.707031 221.324219 80.117188 220.550781 79.601562 C 219.777344 79.085938 218.960938 78.648438 218.101562 78.292969 C 217.242188 77.933594 216.359375 77.667969 215.445312 77.484375 C 214.535156 77.300781 213.613281 77.210938 212.683594 77.207031 L 126.960938 77.207031 C 126.03125 77.210938 125.109375 77.300781 124.195312 77.484375 C 123.285156 77.667969 122.398438 77.933594 121.539062 78.292969 C 120.679688 78.648438 119.863281 79.085938 119.09375 79.601562 C 118.320312 80.117188 117.601562 80.707031 116.945312 81.363281 C 116.289062 82.019531 115.699219 82.738281 115.183594 83.511719 C 114.667969 84.28125 114.230469 85.097656 113.875 85.957031 C 113.515625 86.816406 113.25 87.703125 113.066406 88.613281 C 112.882812 89.527344 112.792969 90.449219 112.789062 91.378906 L 112.789062 156.054688 C 112.792969 156.988281 112.882812 157.90625 113.066406 158.820312 C 113.25 159.730469 113.515625 160.617188 113.875 161.476562 C 114.230469 162.335938 114.667969 163.152344 115.183594 163.925781 C 115.699219 164.699219 116.289062 165.414062 116.945312 166.070312 C 117.601562 166.726562 118.320312 167.316406 119.09375 167.832031 C 119.863281 168.347656 120.679688 168.785156 121.539062 169.140625 C 122.398438 169.5 123.285156 169.769531 124.195312 169.949219 C 125.109375 170.132812 126.03125 170.222656 126.960938 170.226562 Z M 252.230469 96.117188 C 252.347656 96.054688 252.46875 96.007812 252.597656 95.976562 C 252.726562 95.945312 252.855469 95.929688 252.988281 95.933594 C 253.121094 95.933594 253.25 95.953125 253.375 95.992188 C 253.503906 96.027344 253.625 96.078125 253.738281 96.148438 C 253.851562 96.214844 253.953125 96.296875 254.046875 96.390625 C 254.136719 96.484375 254.214844 96.589844 254.28125 96.703125 C 254.347656 96.816406 254.394531 96.9375 254.429688 97.066406 C 254.464844 97.195312 254.480469 97.324219 254.480469 97.457031 L 254.480469 149.976562 C 254.480469 150.109375 254.464844 150.238281 254.429688 150.367188 C 254.394531 150.496094 254.347656 150.617188 254.28125 150.730469 C 254.214844 150.84375 254.136719 150.949219 254.046875 151.042969 C 253.953125 151.140625 253.851562 151.21875 253.738281 151.285156 C 253.625 151.355469 253.503906 151.40625 253.375 151.441406 C 253.25 151.480469 253.121094 151.5 252.988281 151.5 C 252.855469 151.503906 252.726562 151.488281 252.597656 151.457031 C 252.46875 151.425781 252.347656 151.378906 252.230469 151.316406 L 226.851562 137.578125 L 226.851562 109.855469 Z M 120.519531 91.378906 C 120.519531 90.953125 120.5625 90.535156 120.644531 90.121094 C 120.726562 89.707031 120.847656 89.304688 121.011719 88.914062 C 121.171875 88.523438 121.371094 88.152344 121.605469 87.800781 C 121.84375 87.449219 122.109375 87.125 122.40625 86.824219 C 122.707031 86.527344 123.03125 86.261719 123.382812 86.023438 C 123.734375 85.789062 124.105469 85.589844 124.496094 85.429688 C 124.886719 85.265625 125.289062 85.144531 125.703125 85.0625 C 126.117188 84.980469 126.535156 84.9375 126.960938 84.9375 L 212.683594 84.9375 C 213.105469 84.9375 213.523438 84.980469 213.9375 85.0625 C 214.355469 85.144531 214.757812 85.265625 215.148438 85.429688 C 215.539062 85.589844 215.90625 85.789062 216.257812 86.023438 C 216.609375 86.261719 216.9375 86.527344 217.234375 86.824219 C 217.535156 87.125 217.800781 87.449219 218.035156 87.800781 C 218.269531 88.152344 218.46875 88.523438 218.632812 88.914062 C 218.792969 89.304688 218.914062 89.707031 219 90.121094 C 219.082031 90.535156 219.125 90.953125 219.125 91.378906 L 219.125 156.054688 C 219.125 156.480469 219.082031 156.898438 219 157.3125 C 218.914062 157.726562 218.792969 158.128906 218.632812 158.519531 C 218.46875 158.910156 218.269531 159.28125 218.035156 159.632812 C 217.800781 159.984375 217.535156 160.308594 217.234375 160.609375 C 216.9375 160.90625 216.609375 161.175781 216.257812 161.410156 C 215.90625 161.644531 215.539062 161.84375 215.148438 162.003906 C 214.757812 162.167969 214.355469 162.289062 213.9375 162.371094 C 213.523438 162.453125 213.105469 162.496094 212.683594 162.496094 L 126.960938 162.496094 C 126.535156 162.496094 126.117188 162.453125 125.703125 162.371094 C 125.289062 162.289062 124.886719 162.167969 124.496094 162.003906 C 124.105469 161.84375 123.734375 161.644531 123.382812 161.410156 C 123.03125 161.175781 122.707031 160.90625 122.40625 160.609375 C 122.109375 160.308594 121.84375 159.984375 121.605469 159.632812 C 121.371094 159.28125 121.171875 158.910156 121.011719 158.519531 C 120.847656 158.128906 120.726562 157.726562 120.644531 157.3125 C 120.5625 156.898438 120.519531 156.480469 120.519531 156.054688 Z M 120.519531 91.378906 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g fill="#ffffff" fillOpacity="1">
        <g transform="translate(90.61033, 280.605794)">
          <g>
            <path d="M 48.4375 0 L 18.546875 -52.8125 C 19.128906 -47.6875 19.421875 -43.566406 19.421875 -40.453125 L 19.421875 0 L 6.671875 0 L 6.671875 -68.578125 L 23.078125 -68.578125 L 53.390625 -15.328125 C 52.804688 -20.234375 52.515625 -24.695312 52.515625 -28.71875 L 52.515625 -68.578125 L 65.28125 -68.578125 L 65.28125 0 Z M 48.4375 0 " />
          </g>
        </g>
        <g transform="translate(162.598603, 280.605794)">
          <g>
            <path d="M 21.03125 -57.484375 L 21.03125 -36.265625 L 56.125 -36.265625 L 56.125 -25.171875 L 21.03125 -25.171875 L 21.03125 0 L 6.671875 0 L 6.671875 -68.578125 L 57.25 -68.578125 L 57.25 -57.484375 Z M 21.03125 -57.484375 " />
          </g>
        </g>
        <g transform="translate(223.489291, 280.605794)">
          <g>
            <path d="M 37.625 -57.484375 L 37.625 0 L 23.265625 0 L 23.265625 -57.484375 L 1.125 -57.484375 L 1.125 -68.578125 L 59.828125 -68.578125 L 59.828125 -57.484375 Z M 37.625 -57.484375 " />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function VideoNftIcon({
  size = 30,
}: {
  style?: StyleProp<ViewStyle>
  size?: number
  fill?: string
}) {
  return (
    <svg
      width={size}
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height={size}
      preserveAspectRatio="xMidYMid meet"
      version="1.0">
      <defs>
        <g />
        <clipPath id="c37fbc0ffb">
          <path
            d="M 26.261719 4.273438 L 348.730469 4.273438 L 348.730469 370.726562 L 26.261719 370.726562 Z M 26.261719 4.273438 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="433fa59f2a">
          <path
            d="M 31.933594 7.230469 L 343.066406 7.230469 L 343.066406 368 L 31.933594 368 Z M 31.933594 7.230469 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="5428bc48ff">
          <path
            d="M 187.5 7.230469 L 343.066406 95.066406 L 343.066406 279.933594 L 187.5 367.769531 L 31.933594 279.933594 L 31.933594 95.066406 Z M 187.5 7.230469 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="33ff321b75">
          <path
            d="M 112.5 77.089844 L 262.5 77.089844 L 262.5 170.089844 L 112.5 170.089844 Z M 112.5 77.089844 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#c37fbc0ffb)">
        <path
          fill="#ffffff"
          d="M 187.492188 17.609375 C 186.515625 17.609375 185.535156 17.863281 184.660156 18.371094 L 42.4375 100.480469 C 40.691406 101.492188 39.605469 103.371094 39.605469 105.390625 L 39.605469 269.613281 C 39.605469 271.632812 40.691406 273.511719 42.4375 274.519531 L 184.660156 356.632812 C 186.40625 357.640625 188.578125 357.640625 190.328125 356.632812 L 332.550781 274.519531 C 334.296875 273.511719 335.386719 271.632812 335.386719 269.613281 L 335.386719 105.390625 C 335.386719 103.371094 334.296875 101.492188 332.550781 100.480469 L 190.328125 18.371094 C 189.453125 17.863281 188.472656 17.609375 187.492188 17.609375 Z M 187.492188 370.726562 C 184.207031 370.726562 180.921875 369.882812 177.988281 368.191406 L 35.765625 286.074219 C 29.902344 282.691406 26.261719 276.382812 26.261719 269.613281 L 26.261719 105.390625 C 26.261719 98.621094 29.902344 92.308594 35.765625 88.925781 L 177.988281 6.8125 C 183.851562 3.425781 191.136719 3.425781 197 6.8125 L 339.222656 88.925781 C 345.085938 92.308594 348.730469 98.621094 348.730469 105.390625 L 348.730469 269.613281 C 348.730469 276.382812 345.085938 282.691406 339.222656 286.078125 L 197 368.191406 C 194.070312 369.882812 190.78125 370.726562 187.492188 370.726562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#433fa59f2a)">
        <g clipPath="url(#5428bc48ff)">
          <path
            fill="#ffffff"
            d="M 31.933594 7.230469 L 343.066406 7.230469 L 343.066406 368.191406 L 31.933594 368.191406 Z M 31.933594 7.230469 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g clipPath="url(#33ff321b75)">
        <path
          fill="#000000"
          d="M 126.960938 170.226562 L 212.683594 170.226562 C 213.613281 170.222656 214.535156 170.132812 215.445312 169.949219 C 216.359375 169.769531 217.242188 169.5 218.101562 169.140625 C 218.960938 168.785156 219.777344 168.347656 220.550781 167.832031 C 221.324219 167.316406 222.039062 166.726562 222.695312 166.070312 C 223.355469 165.414062 223.941406 164.699219 224.460938 163.925781 C 224.976562 163.152344 225.414062 162.335938 225.769531 161.476562 C 226.125 160.617188 226.394531 159.730469 226.578125 158.820312 C 226.757812 157.90625 226.851562 156.988281 226.851562 156.054688 L 226.851562 146.367188 L 248.554688 158.117188 C 248.902344 158.304688 249.265625 158.472656 249.636719 158.613281 C 250.011719 158.757812 250.390625 158.875 250.777344 158.972656 C 251.167969 159.066406 251.558594 159.132812 251.953125 159.175781 C 252.351562 159.21875 252.75 159.238281 253.148438 159.230469 C 253.546875 159.222656 253.945312 159.1875 254.339844 159.128906 C 254.734375 159.066406 255.121094 158.984375 255.503906 158.875 C 255.890625 158.761719 256.265625 158.628906 256.628906 158.472656 C 256.996094 158.3125 257.351562 158.132812 257.691406 157.925781 C 258.035156 157.722656 258.363281 157.496094 258.675781 157.25 C 258.992188 157.003906 259.289062 156.738281 259.566406 156.453125 C 259.847656 156.167969 260.105469 155.867188 260.347656 155.546875 C 260.585938 155.230469 260.804688 154.894531 261 154.550781 C 261.199219 154.203125 261.371094 153.84375 261.523438 153.476562 C 261.675781 153.105469 261.800781 152.726562 261.902344 152.34375 C 262.003906 151.957031 262.082031 151.566406 262.132812 151.171875 C 262.183594 150.773438 262.210938 150.378906 262.210938 149.976562 L 262.210938 97.457031 C 262.210938 97.058594 262.183594 96.660156 262.132812 96.265625 C 262.082031 95.867188 262.003906 95.476562 261.902344 95.09375 C 261.800781 94.707031 261.675781 94.328125 261.523438 93.960938 C 261.371094 93.589844 261.199219 93.230469 261 92.886719 C 260.804688 92.539062 260.585938 92.207031 260.347656 91.886719 C 260.105469 91.566406 259.847656 91.265625 259.566406 90.980469 C 259.289062 90.695312 258.992188 90.429688 258.675781 90.183594 C 258.363281 89.9375 258.035156 89.710938 257.691406 89.507812 C 257.351562 89.304688 256.996094 89.121094 256.628906 88.964844 C 256.265625 88.804688 255.890625 88.671875 255.503906 88.5625 C 255.121094 88.449219 254.734375 88.367188 254.339844 88.308594 C 253.945312 88.246094 253.546875 88.214844 253.148438 88.207031 C 252.75 88.195312 252.351562 88.214844 251.953125 88.257812 C 251.558594 88.300781 251.167969 88.371094 250.777344 88.464844 C 250.390625 88.558594 250.011719 88.675781 249.636719 88.820312 C 249.265625 88.960938 248.902344 89.128906 248.554688 89.320312 L 226.851562 101.066406 L 226.851562 91.378906 C 226.851562 90.449219 226.757812 89.527344 226.578125 88.613281 C 226.394531 87.703125 226.125 86.816406 225.769531 85.957031 C 225.414062 85.097656 224.976562 84.28125 224.460938 83.511719 C 223.941406 82.738281 223.355469 82.019531 222.695312 81.363281 C 222.039062 80.707031 221.324219 80.117188 220.550781 79.601562 C 219.777344 79.085938 218.960938 78.648438 218.101562 78.292969 C 217.242188 77.933594 216.359375 77.667969 215.445312 77.484375 C 214.535156 77.300781 213.613281 77.210938 212.683594 77.207031 L 126.960938 77.207031 C 126.03125 77.210938 125.109375 77.300781 124.195312 77.484375 C 123.285156 77.667969 122.398438 77.933594 121.539062 78.292969 C 120.679688 78.648438 119.863281 79.085938 119.09375 79.601562 C 118.320312 80.117188 117.601562 80.707031 116.945312 81.363281 C 116.289062 82.019531 115.699219 82.738281 115.183594 83.511719 C 114.667969 84.28125 114.230469 85.097656 113.875 85.957031 C 113.515625 86.816406 113.25 87.703125 113.066406 88.613281 C 112.882812 89.527344 112.792969 90.449219 112.789062 91.378906 L 112.789062 156.054688 C 112.792969 156.988281 112.882812 157.90625 113.066406 158.820312 C 113.25 159.730469 113.515625 160.617188 113.875 161.476562 C 114.230469 162.335938 114.667969 163.152344 115.183594 163.925781 C 115.699219 164.699219 116.289062 165.414062 116.945312 166.070312 C 117.601562 166.726562 118.320312 167.316406 119.09375 167.832031 C 119.863281 168.347656 120.679688 168.785156 121.539062 169.140625 C 122.398438 169.5 123.285156 169.769531 124.195312 169.949219 C 125.109375 170.132812 126.03125 170.222656 126.960938 170.226562 Z M 252.230469 96.117188 C 252.347656 96.054688 252.46875 96.007812 252.597656 95.976562 C 252.726562 95.945312 252.855469 95.929688 252.988281 95.933594 C 253.121094 95.933594 253.25 95.953125 253.375 95.992188 C 253.503906 96.027344 253.625 96.078125 253.738281 96.148438 C 253.851562 96.214844 253.953125 96.296875 254.046875 96.390625 C 254.136719 96.484375 254.214844 96.589844 254.28125 96.703125 C 254.347656 96.816406 254.394531 96.9375 254.429688 97.066406 C 254.464844 97.195312 254.480469 97.324219 254.480469 97.457031 L 254.480469 149.976562 C 254.480469 150.109375 254.464844 150.238281 254.429688 150.367188 C 254.394531 150.496094 254.347656 150.617188 254.28125 150.730469 C 254.214844 150.84375 254.136719 150.949219 254.046875 151.042969 C 253.953125 151.140625 253.851562 151.21875 253.738281 151.289062 C 253.625 151.355469 253.503906 151.40625 253.375 151.441406 C 253.25 151.480469 253.121094 151.5 252.988281 151.5 C 252.855469 151.503906 252.726562 151.488281 252.597656 151.457031 C 252.46875 151.425781 252.347656 151.378906 252.230469 151.316406 L 226.851562 137.578125 L 226.851562 109.855469 Z M 120.519531 91.378906 C 120.519531 90.953125 120.5625 90.535156 120.644531 90.121094 C 120.726562 89.707031 120.847656 89.304688 121.011719 88.914062 C 121.171875 88.523438 121.371094 88.152344 121.605469 87.800781 C 121.84375 87.449219 122.109375 87.125 122.40625 86.824219 C 122.707031 86.527344 123.03125 86.261719 123.382812 86.023438 C 123.734375 85.789062 124.105469 85.589844 124.496094 85.429688 C 124.886719 85.265625 125.289062 85.144531 125.703125 85.0625 C 126.117188 84.980469 126.535156 84.9375 126.960938 84.9375 L 212.683594 84.9375 C 213.105469 84.9375 213.523438 84.980469 213.9375 85.0625 C 214.355469 85.144531 214.757812 85.265625 215.148438 85.429688 C 215.539062 85.589844 215.90625 85.789062 216.257812 86.023438 C 216.609375 86.261719 216.9375 86.527344 217.234375 86.824219 C 217.535156 87.125 217.800781 87.449219 218.035156 87.800781 C 218.269531 88.152344 218.46875 88.523438 218.632812 88.914062 C 218.792969 89.304688 218.914062 89.707031 219 90.121094 C 219.082031 90.535156 219.125 90.953125 219.125 91.378906 L 219.125 156.054688 C 219.125 156.480469 219.082031 156.898438 219 157.3125 C 218.914062 157.726562 218.792969 158.128906 218.632812 158.519531 C 218.46875 158.910156 218.269531 159.28125 218.035156 159.632812 C 217.800781 159.984375 217.535156 160.308594 217.234375 160.609375 C 216.9375 160.90625 216.609375 161.175781 216.257812 161.410156 C 215.90625 161.644531 215.539062 161.84375 215.148438 162.003906 C 214.757812 162.167969 214.355469 162.289062 213.9375 162.371094 C 213.523438 162.453125 213.105469 162.496094 212.683594 162.496094 L 126.960938 162.496094 C 126.535156 162.496094 126.117188 162.453125 125.703125 162.371094 C 125.289062 162.289062 124.886719 162.167969 124.496094 162.003906 C 124.105469 161.84375 123.734375 161.644531 123.382812 161.410156 C 123.03125 161.175781 122.707031 160.90625 122.40625 160.609375 C 122.109375 160.308594 121.84375 159.984375 121.605469 159.632812 C 121.371094 159.28125 121.171875 158.910156 121.011719 158.519531 C 120.847656 158.128906 120.726562 157.726562 120.644531 157.3125 C 120.5625 156.898438 120.519531 156.480469 120.519531 156.054688 Z M 120.519531 91.378906 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g fill="#000000" fillOpacity="1">
        <g transform="translate(90.61033, 280.605765)">
          <g>
            <path d="M 48.4375 0 L 18.546875 -52.8125 C 19.128906 -47.6875 19.421875 -43.566406 19.421875 -40.453125 L 19.421875 0 L 6.671875 0 L 6.671875 -68.578125 L 23.078125 -68.578125 L 53.390625 -15.328125 C 52.804688 -20.234375 52.515625 -24.695312 52.515625 -28.71875 L 52.515625 -68.578125 L 65.28125 -68.578125 L 65.28125 0 Z M 48.4375 0 " />
          </g>
        </g>
        <g transform="translate(162.598603, 280.605765)">
          <g>
            <path d="M 21.03125 -57.484375 L 21.03125 -36.265625 L 56.125 -36.265625 L 56.125 -25.171875 L 21.03125 -25.171875 L 21.03125 0 L 6.671875 0 L 6.671875 -68.578125 L 57.25 -68.578125 L 57.25 -57.484375 Z M 21.03125 -57.484375 " />
          </g>
        </g>
        <g transform="translate(223.489291, 280.605765)">
          <g>
            <path d="M 37.625 -57.484375 L 37.625 0 L 23.265625 0 L 23.265625 -57.484375 L 1.125 -57.484375 L 1.125 -68.578125 L 59.828125 -68.578125 L 59.828125 -57.484375 Z M 37.625 -57.484375 " />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function VideoIcon({
  style,
  size,
  strokeWidth = 2,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      width={size || 24}
      height={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}>
      <Path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" />
      <Path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <Rect width="8" height="6" x="2" y="12" rx="1" />
      <Path d="m10 15.5 4 2.5v-6l-4 2.5" />
    </Svg>
  )
}

export function TwitterIcon({
  style,
  size,
  strokeWidth = 2,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="white"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      width={size}
      height={size}
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"
      />
    </Svg>
  )
}

export function NftIcon() {
  return (
    <svg
      width={30}
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height={30}
      preserveAspectRatio="xMidYMid meet"
      version="1.0">
      <defs>
        <g />
        <clipPath id="4b5479ac7c">
          <path
            d="M 26.261719 4.273438 L 348.730469 4.273438 L 348.730469 370.726562 L 26.261719 370.726562 Z M 26.261719 4.273438 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="17ffb2267e">
          <path
            d="M 31.769531 10.191406 L 342.898438 10.191406 L 342.898438 371 L 31.769531 371 Z M 31.769531 10.191406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="7b2e066573">
          <path
            d="M 187.335938 10.191406 L 342.898438 98.023438 L 342.898438 282.894531 L 187.335938 370.726562 L 31.769531 282.894531 L 31.769531 98.023438 Z M 187.335938 10.191406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="def56b2921">
          <path
            d="M 131.9375 73.332031 L 242.9375 73.332031 L 242.9375 179.832031 L 131.9375 179.832031 Z M 131.9375 73.332031 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#4b5479ac7c)">
        <path
          fill="#452996"
          d="M 187.492188 17.609375 C 186.515625 17.609375 185.535156 17.863281 184.660156 18.371094 L 42.4375 100.480469 C 40.691406 101.492188 39.605469 103.371094 39.605469 105.390625 L 39.605469 269.613281 C 39.605469 271.632812 40.691406 273.511719 42.4375 274.519531 L 184.660156 356.632812 C 186.40625 357.640625 188.578125 357.640625 190.328125 356.632812 L 332.550781 274.519531 C 334.296875 273.511719 335.386719 271.632812 335.386719 269.613281 L 335.386719 105.390625 C 335.386719 103.371094 334.296875 101.492188 332.550781 100.480469 L 190.328125 18.371094 C 189.453125 17.863281 188.472656 17.609375 187.492188 17.609375 Z M 187.492188 370.726562 C 184.207031 370.726562 180.921875 369.882812 177.988281 368.191406 L 35.765625 286.074219 C 29.902344 282.691406 26.261719 276.382812 26.261719 269.613281 L 26.261719 105.390625 C 26.261719 98.621094 29.902344 92.308594 35.765625 88.925781 L 177.988281 6.8125 C 183.851562 3.425781 191.136719 3.425781 197 6.8125 L 339.222656 88.925781 C 345.085938 92.308594 348.730469 98.621094 348.730469 105.390625 L 348.730469 269.613281 C 348.730469 276.382812 345.085938 282.691406 339.222656 286.078125 L 197 368.191406 C 194.070312 369.882812 190.78125 370.726562 187.492188 370.726562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#17ffb2267e)">
        <g clipPath="url(#7b2e066573)">
          <path
            fill="#452996"
            d="M 31.769531 10.191406 L 342.898438 10.191406 L 342.898438 371.148438 L 31.769531 371.148438 Z M 31.769531 10.191406 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g clipPath="url(#def56b2921)">
        <path
          fill="#ffffff"
          d="M 240.207031 76.3125 C 239.304688 75.40625 238.265625 74.710938 237.082031 74.21875 C 235.902344 73.730469 234.671875 73.488281 233.394531 73.492188 L 141.570312 73.492188 C 140.9375 73.492188 140.308594 73.550781 139.6875 73.675781 C 139.066406 73.800781 138.464844 73.980469 137.878906 74.222656 C 137.296875 74.464844 136.742188 74.761719 136.214844 75.113281 C 135.6875 75.464844 135.199219 75.867188 134.753906 76.3125 C 134.304688 76.761719 133.90625 77.246094 133.554688 77.773438 C 133.203125 78.300781 132.90625 78.855469 132.664062 79.441406 C 132.421875 80.023438 132.238281 80.625 132.117188 81.246094 C 131.992188 81.867188 131.929688 82.496094 131.933594 83.128906 L 131.933594 169.75 C 131.929688 170.382812 131.992188 171.011719 132.117188 171.632812 C 132.238281 172.253906 132.421875 172.855469 132.664062 173.441406 C 132.90625 174.023438 133.203125 174.578125 133.554688 175.105469 C 133.90625 175.632812 134.304688 176.117188 134.753906 176.566406 C 135.203125 177.015625 135.6875 177.414062 136.214844 177.765625 C 136.742188 178.117188 137.296875 178.414062 137.878906 178.65625 C 138.464844 178.898438 139.066406 179.078125 139.6875 179.203125 C 140.308594 179.328125 140.9375 179.386719 141.570312 179.386719 L 233.394531 179.386719 C 234.027344 179.386719 234.652344 179.328125 235.273438 179.203125 C 235.894531 179.078125 236.496094 178.898438 237.082031 178.65625 C 237.664062 178.414062 238.222656 178.117188 238.746094 177.765625 C 239.273438 177.414062 239.761719 177.015625 240.207031 176.566406 C 240.65625 176.117188 241.054688 175.632812 241.40625 175.105469 C 241.757812 174.578125 242.054688 174.023438 242.296875 173.441406 C 242.539062 172.855469 242.722656 172.253906 242.84375 171.632812 C 242.96875 171.011719 243.03125 170.382812 243.03125 169.75 L 243.03125 83.128906 C 243.035156 81.847656 242.789062 80.621094 242.300781 79.4375 C 241.8125 78.257812 241.113281 77.214844 240.207031 76.3125 Z M 237.4375 169.75 C 237.4375 170.019531 237.414062 170.28125 237.363281 170.542969 C 237.3125 170.800781 237.234375 171.054688 237.132812 171.300781 C 237.03125 171.546875 236.90625 171.78125 236.757812 172 C 236.609375 172.222656 236.441406 172.425781 236.253906 172.613281 C 236.066406 172.800781 235.863281 172.96875 235.640625 173.117188 C 235.421875 173.265625 235.1875 173.390625 234.941406 173.492188 C 234.695312 173.59375 234.441406 173.667969 234.183594 173.722656 C 233.921875 173.773438 233.65625 173.796875 233.390625 173.796875 L 141.570312 173.796875 C 141.304688 173.796875 141.039062 173.773438 140.777344 173.71875 C 140.519531 173.667969 140.265625 173.589844 140.019531 173.488281 C 139.773438 173.386719 139.542969 173.261719 139.320312 173.117188 C 139.101562 172.96875 138.894531 172.800781 138.707031 172.613281 C 138.519531 172.425781 138.351562 172.222656 138.203125 172 C 138.054688 171.777344 137.933594 171.546875 137.832031 171.300781 C 137.730469 171.054688 137.652344 170.800781 137.601562 170.542969 C 137.546875 170.28125 137.523438 170.015625 137.523438 169.75 L 137.523438 83.128906 C 137.523438 82.863281 137.546875 82.597656 137.597656 82.335938 C 137.652344 82.078125 137.726562 81.824219 137.828125 81.578125 C 137.929688 81.332031 138.054688 81.097656 138.203125 80.878906 C 138.351562 80.65625 138.519531 80.453125 138.707031 80.265625 C 138.894531 80.078125 139.097656 79.910156 139.320312 79.761719 C 139.539062 79.613281 139.773438 79.488281 140.019531 79.386719 C 140.265625 79.285156 140.519531 79.210938 140.777344 79.15625 C 141.039062 79.105469 141.304688 79.082031 141.570312 79.082031 L 233.394531 79.082031 C 233.660156 79.082031 233.921875 79.105469 234.183594 79.160156 C 234.441406 79.210938 234.695312 79.289062 234.941406 79.390625 C 235.1875 79.492188 235.421875 79.617188 235.640625 79.761719 C 235.863281 79.910156 236.066406 80.078125 236.253906 80.265625 C 236.441406 80.453125 236.609375 80.660156 236.757812 80.878906 C 236.90625 81.101562 237.03125 81.332031 237.132812 81.578125 C 237.234375 81.824219 237.308594 82.078125 237.363281 82.339844 C 237.414062 82.597656 237.441406 82.863281 237.441406 83.128906 Z M 237.4375 169.75 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="#ffffff"
        d="M 169.660156 122.777344 C 170.558594 122.777344 171.449219 122.6875 172.332031 122.511719 C 173.210938 122.335938 174.070312 122.078125 174.898438 121.734375 C 175.730469 121.390625 176.519531 120.96875 177.265625 120.46875 C 178.015625 119.96875 178.707031 119.402344 179.339844 118.765625 C 179.976562 118.128906 180.546875 117.4375 181.042969 116.691406 C 181.542969 115.941406 181.964844 115.152344 182.308594 114.324219 C 182.652344 113.492188 182.914062 112.636719 183.089844 111.753906 C 183.265625 110.871094 183.351562 109.980469 183.351562 109.082031 C 183.351562 108.183594 183.265625 107.292969 183.089844 106.410156 C 182.914062 105.53125 182.652344 104.671875 182.308594 103.84375 C 181.964844 103.011719 181.542969 102.222656 181.042969 101.476562 C 180.546875 100.726562 179.976562 100.035156 179.339844 99.402344 C 178.707031 98.765625 178.015625 98.199219 177.265625 97.699219 C 176.519531 97.199219 175.730469 96.777344 174.898438 96.433594 C 174.070312 96.089844 173.210938 95.828125 172.332031 95.652344 C 171.449219 95.476562 170.558594 95.390625 169.660156 95.390625 C 168.761719 95.390625 167.871094 95.476562 166.988281 95.652344 C 166.105469 95.828125 165.25 96.089844 164.417969 96.433594 C 163.589844 96.777344 162.800781 97.199219 162.050781 97.699219 C 161.304688 98.199219 160.613281 98.765625 159.976562 99.402344 C 159.339844 100.035156 158.773438 100.726562 158.273438 101.476562 C 157.773438 102.222656 157.351562 103.011719 157.007812 103.84375 C 156.664062 104.671875 156.40625 105.53125 156.230469 106.410156 C 156.054688 107.292969 155.964844 108.183594 155.964844 109.082031 C 155.96875 109.980469 156.054688 110.871094 156.230469 111.753906 C 156.410156 112.636719 156.667969 113.492188 157.011719 114.320312 C 157.355469 115.152344 157.78125 115.941406 158.277344 116.6875 C 158.777344 117.433594 159.347656 118.125 159.980469 118.761719 C 160.617188 119.398438 161.308594 119.964844 162.054688 120.464844 C 162.804688 120.964844 163.589844 121.386719 164.421875 121.730469 C 165.253906 122.074219 166.109375 122.335938 166.988281 122.511719 C 167.871094 122.6875 168.761719 122.773438 169.660156 122.777344 Z M 169.660156 100.980469 C 170.191406 100.980469 170.71875 101.035156 171.238281 101.136719 C 171.761719 101.242188 172.269531 101.394531 172.757812 101.597656 C 173.25 101.800781 173.71875 102.050781 174.160156 102.347656 C 174.601562 102.644531 175.011719 102.980469 175.386719 103.355469 C 175.761719 103.730469 176.097656 104.140625 176.394531 104.582031 C 176.691406 105.027344 176.941406 105.492188 177.144531 105.984375 C 177.347656 106.476562 177.5 106.980469 177.605469 107.503906 C 177.707031 108.027344 177.757812 108.550781 177.757812 109.085938 C 177.757812 109.617188 177.707031 110.144531 177.605469 110.664062 C 177.5 111.1875 177.347656 111.691406 177.140625 112.183594 C 176.9375 112.675781 176.6875 113.144531 176.394531 113.585938 C 176.097656 114.027344 175.761719 114.4375 175.386719 114.8125 C 175.011719 115.1875 174.601562 115.523438 174.160156 115.820312 C 173.714844 116.117188 173.25 116.363281 172.757812 116.570312 C 172.265625 116.773438 171.757812 116.925781 171.238281 117.03125 C 170.714844 117.132812 170.1875 117.183594 169.65625 117.183594 C 169.125 117.183594 168.597656 117.132812 168.078125 117.03125 C 167.554688 116.925781 167.046875 116.773438 166.558594 116.570312 C 166.066406 116.363281 165.597656 116.117188 165.15625 115.820312 C 164.714844 115.523438 164.304688 115.1875 163.929688 114.8125 C 163.550781 114.4375 163.214844 114.027344 162.921875 113.585938 C 162.625 113.140625 162.375 112.675781 162.171875 112.183594 C 161.96875 111.691406 161.816406 111.1875 161.710938 110.664062 C 161.605469 110.144531 161.554688 109.617188 161.554688 109.082031 C 161.554688 108.550781 161.609375 108.023438 161.710938 107.503906 C 161.816406 106.980469 161.972656 106.476562 162.175781 105.984375 C 162.378906 105.492188 162.628906 105.027344 162.925781 104.582031 C 163.21875 104.140625 163.554688 103.734375 163.933594 103.355469 C 164.308594 102.980469 164.71875 102.644531 165.160156 102.347656 C 165.601562 102.054688 166.066406 101.804688 166.558594 101.601562 C 167.050781 101.394531 167.558594 101.242188 168.078125 101.136719 C 168.601562 101.035156 169.128906 100.980469 169.660156 100.980469 Z M 169.660156 100.980469 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 205.285156 109.953125 C 204.808594 109.082031 204.148438 108.386719 203.304688 107.867188 C 202.460938 107.34375 201.542969 107.066406 200.550781 107.03125 C 199.625 106.996094 198.742188 107.175781 197.902344 107.574219 C 197.0625 107.972656 196.363281 108.539062 195.800781 109.277344 L 174.914062 136.804688 L 169.363281 131.25 C 169.074219 130.964844 168.757812 130.710938 168.417969 130.492188 C 168.074219 130.269531 167.710938 130.089844 167.332031 129.949219 C 166.949219 129.808594 166.558594 129.707031 166.152344 129.648438 C 165.75 129.59375 165.347656 129.578125 164.941406 129.609375 C 164.535156 129.636719 164.136719 129.710938 163.746094 129.828125 C 163.355469 129.941406 162.984375 130.097656 162.628906 130.292969 C 162.269531 130.488281 161.9375 130.722656 161.632812 130.988281 C 161.324219 131.253906 161.050781 131.550781 160.808594 131.878906 L 148.492188 148.441406 C 148.179688 148.863281 147.929688 149.320312 147.742188 149.8125 C 147.554688 150.304688 147.441406 150.8125 147.394531 151.335938 C 147.351562 151.859375 147.378906 152.378906 147.476562 152.898438 C 147.578125 153.414062 147.746094 153.90625 147.984375 154.375 C 148.222656 154.84375 148.519531 155.273438 148.875 155.660156 C 149.230469 156.046875 149.632812 156.378906 150.082031 156.652344 C 150.53125 156.925781 151.007812 157.136719 151.515625 157.277344 C 152.019531 157.417969 152.539062 157.488281 153.0625 157.488281 L 221.925781 157.453125 C 222.480469 157.449219 223.019531 157.371094 223.546875 157.210938 C 224.078125 157.054688 224.570312 156.824219 225.03125 156.519531 C 225.496094 156.21875 225.902344 155.855469 226.257812 155.433594 C 226.613281 155.011719 226.902344 154.546875 227.121094 154.042969 C 227.476562 153.238281 227.632812 152.394531 227.589844 151.515625 C 227.550781 150.636719 227.3125 149.8125 226.882812 149.042969 Z M 152.960938 151.8125 C 152.964844 151.796875 152.972656 151.789062 152.980469 151.777344 L 165.410156 135.207031 L 170.960938 140.761719 C 171.25 141.046875 171.5625 141.300781 171.902344 141.519531 C 172.242188 141.742188 172.601562 141.921875 172.984375 142.0625 C 173.363281 142.207031 173.753906 142.304688 174.152344 142.363281 C 174.554688 142.421875 174.957031 142.4375 175.363281 142.410156 C 175.765625 142.382812 176.164062 142.308594 176.550781 142.195312 C 176.941406 142.082031 177.3125 141.929688 177.667969 141.738281 C 178.027344 141.542969 178.355469 141.316406 178.664062 141.050781 C 178.972656 140.785156 179.246094 140.492188 179.492188 140.167969 L 200.390625 112.660156 L 221.921875 151.867188 Z M 152.960938 151.8125 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <g fill="#ffffff" fillOpacity="1">
        <g transform="translate(90.61033, 280.605765)">
          <g>
            <path d="M 48.4375 0 L 18.546875 -52.8125 C 19.128906 -47.6875 19.421875 -43.566406 19.421875 -40.453125 L 19.421875 0 L 6.671875 0 L 6.671875 -68.578125 L 23.078125 -68.578125 L 53.390625 -15.328125 C 52.804688 -20.234375 52.515625 -24.695312 52.515625 -28.71875 L 52.515625 -68.578125 L 65.28125 -68.578125 L 65.28125 0 Z M 48.4375 0 " />
          </g>
        </g>
        <g transform="translate(162.598603, 280.605765)">
          <g>
            <path d="M 21.03125 -57.484375 L 21.03125 -36.265625 L 56.125 -36.265625 L 56.125 -25.171875 L 21.03125 -25.171875 L 21.03125 0 L 6.671875 0 L 6.671875 -68.578125 L 57.25 -68.578125 L 57.25 -57.484375 Z M 21.03125 -57.484375 " />
          </g>
        </g>
        <g transform="translate(223.489291, 280.605765)">
          <g>
            <path d="M 37.625 -57.484375 L 37.625 0 L 23.265625 0 L 23.265625 -57.484375 L 1.125 -57.484375 L 1.125 -68.578125 L 59.828125 -68.578125 L 59.828125 -57.484375 Z M 37.625 -57.484375 " />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function NftIconDark() {
  return (
    <svg
      width={30}
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height={30}
      preserveAspectRatio="xMidYMid meet"
      version="1.0">
      <defs>
        <g />
        <clipPath id="231647cabf">
          <path
            d="M 26.261719 4.273438 L 348.730469 4.273438 L 348.730469 370.726562 L 26.261719 370.726562 Z M 26.261719 4.273438 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="e9762edaa4">
          <path
            d="M 31.933594 7.230469 L 343.066406 7.230469 L 343.066406 368 L 31.933594 368 Z M 31.933594 7.230469 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="f31adbcdc3">
          <path
            d="M 187.5 7.230469 L 343.066406 95.066406 L 343.066406 279.933594 L 187.5 367.769531 L 31.933594 279.933594 L 31.933594 95.066406 Z M 187.5 7.230469 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="5797f4397d">
          <path
            d="M 131.9375 73.332031 L 242.9375 73.332031 L 242.9375 179.832031 L 131.9375 179.832031 Z M 131.9375 73.332031 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#231647cabf)">
        <path
          fill="#ffffff"
          d="M 187.492188 17.609375 C 186.515625 17.609375 185.535156 17.863281 184.660156 18.371094 L 42.4375 100.480469 C 40.691406 101.492188 39.605469 103.371094 39.605469 105.390625 L 39.605469 269.613281 C 39.605469 271.632812 40.691406 273.511719 42.4375 274.519531 L 184.660156 356.632812 C 186.40625 357.640625 188.578125 357.640625 190.328125 356.632812 L 332.550781 274.519531 C 334.296875 273.511719 335.386719 271.632812 335.386719 269.613281 L 335.386719 105.390625 C 335.386719 103.371094 334.296875 101.492188 332.550781 100.480469 L 190.328125 18.371094 C 189.453125 17.863281 188.472656 17.609375 187.492188 17.609375 Z M 187.492188 370.726562 C 184.207031 370.726562 180.921875 369.882812 177.988281 368.191406 L 35.765625 286.074219 C 29.902344 282.691406 26.261719 276.382812 26.261719 269.613281 L 26.261719 105.390625 C 26.261719 98.621094 29.902344 92.308594 35.765625 88.925781 L 177.988281 6.8125 C 183.851562 3.425781 191.136719 3.425781 197 6.8125 L 339.222656 88.925781 C 345.085938 92.308594 348.730469 98.621094 348.730469 105.390625 L 348.730469 269.613281 C 348.730469 276.382812 345.085938 282.691406 339.222656 286.078125 L 197 368.191406 C 194.070312 369.882812 190.78125 370.726562 187.492188 370.726562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#e9762edaa4)">
        <g clipPath="url(#f31adbcdc3)">
          <path
            fill="#ffffff"
            d="M 31.933594 7.230469 L 343.066406 7.230469 L 343.066406 368.191406 L 31.933594 368.191406 Z M 31.933594 7.230469 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g clipPath="url(#5797f4397d)">
        <path
          fill="#000000"
          d="M 240.09375 76.320312 C 239.191406 75.410156 238.152344 74.710938 236.972656 74.222656 C 235.792969 73.730469 234.5625 73.488281 233.285156 73.492188 L 141.558594 73.492188 C 140.925781 73.492188 140.300781 73.554688 139.679688 73.675781 C 139.058594 73.800781 138.457031 73.984375 137.875 74.226562 C 137.289062 74.46875 136.734375 74.765625 136.210938 75.117188 C 135.683594 75.46875 135.199219 75.871094 134.75 76.320312 C 134.304688 76.769531 133.90625 77.253906 133.554688 77.78125 C 133.203125 78.308594 132.90625 78.867188 132.664062 79.453125 C 132.421875 80.039062 132.238281 80.644531 132.117188 81.265625 C 131.992188 81.886719 131.929688 82.515625 131.933594 83.148438 L 131.933594 169.964844 C 131.929688 170.597656 131.992188 171.226562 132.117188 171.847656 C 132.238281 172.472656 132.421875 173.074219 132.664062 173.660156 C 132.90625 174.246094 133.203125 174.804688 133.554688 175.332031 C 133.90625 175.859375 134.304688 176.347656 134.75 176.792969 C 135.199219 177.242188 135.683594 177.644531 136.210938 177.996094 C 136.734375 178.347656 137.289062 178.644531 137.875 178.886719 C 138.457031 179.128906 139.058594 179.3125 139.679688 179.4375 C 140.300781 179.558594 140.925781 179.621094 141.558594 179.621094 L 233.285156 179.621094 C 233.917969 179.621094 234.542969 179.558594 235.164062 179.4375 C 235.785156 179.3125 236.386719 179.128906 236.96875 178.886719 C 237.554688 178.644531 238.109375 178.347656 238.632812 177.996094 C 239.160156 177.644531 239.644531 177.242188 240.09375 176.792969 C 240.539062 176.347656 240.941406 175.859375 241.289062 175.332031 C 241.640625 174.804688 241.9375 174.246094 242.179688 173.660156 C 242.421875 173.074219 242.605469 172.472656 242.726562 171.847656 C 242.851562 171.226562 242.914062 170.597656 242.914062 169.964844 L 242.914062 83.148438 C 242.917969 81.867188 242.671875 80.636719 242.183594 79.453125 C 241.695312 78.265625 241 77.222656 240.09375 76.320312 Z M 237.328125 169.964844 C 237.328125 170.230469 237.300781 170.496094 237.25 170.757812 C 237.199219 171.015625 237.121094 171.269531 237.023438 171.515625 C 236.921875 171.761719 236.796875 171.996094 236.648438 172.21875 C 236.5 172.441406 236.332031 172.644531 236.144531 172.832031 C 235.957031 173.023438 235.753906 173.191406 235.53125 173.339844 C 235.3125 173.484375 235.078125 173.609375 234.832031 173.710938 C 234.585938 173.8125 234.335938 173.890625 234.074219 173.941406 C 233.8125 173.992188 233.550781 174.019531 233.285156 174.019531 L 141.558594 174.019531 C 141.292969 174.019531 141.03125 173.992188 140.769531 173.941406 C 140.507812 173.890625 140.257812 173.8125 140.011719 173.710938 C 139.765625 173.609375 139.535156 173.484375 139.3125 173.335938 C 139.09375 173.1875 138.886719 173.019531 138.699219 172.832031 C 138.511719 172.644531 138.34375 172.4375 138.199219 172.21875 C 138.050781 171.996094 137.925781 171.761719 137.824219 171.515625 C 137.722656 171.269531 137.644531 171.015625 137.59375 170.753906 C 137.542969 170.496094 137.515625 170.230469 137.515625 169.964844 L 137.515625 83.148438 C 137.515625 82.882812 137.542969 82.617188 137.59375 82.359375 C 137.644531 82.097656 137.722656 81.84375 137.824219 81.597656 C 137.921875 81.351562 138.046875 81.117188 138.195312 80.894531 C 138.34375 80.671875 138.511719 80.46875 138.699219 80.28125 C 138.886719 80.089844 139.089844 79.921875 139.3125 79.777344 C 139.53125 79.628906 139.765625 79.503906 140.011719 79.402344 C 140.257812 79.300781 140.507812 79.222656 140.769531 79.171875 C 141.03125 79.121094 141.292969 79.09375 141.558594 79.09375 L 233.285156 79.09375 C 233.550781 79.09375 233.8125 79.121094 234.074219 79.171875 C 234.335938 79.222656 234.585938 79.300781 234.832031 79.402344 C 235.078125 79.503906 235.3125 79.628906 235.53125 79.777344 C 235.753906 79.925781 235.957031 80.09375 236.144531 80.28125 C 236.332031 80.46875 236.5 80.675781 236.648438 80.894531 C 236.792969 81.117188 236.917969 81.351562 237.019531 81.597656 C 237.121094 81.84375 237.199219 82.097656 237.25 82.359375 C 237.300781 82.621094 237.328125 82.882812 237.328125 83.148438 Z M 237.328125 169.964844 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="#000000"
        d="M 169.621094 122.886719 C 170.519531 122.886719 171.40625 122.796875 172.289062 122.621094 C 173.167969 122.445312 174.023438 122.183594 174.855469 121.839844 C 175.683594 121.496094 176.472656 121.074219 177.21875 120.574219 C 177.964844 120.070312 178.65625 119.503906 179.292969 118.867188 C 179.925781 118.230469 180.492188 117.535156 180.992188 116.785156 C 181.492188 116.035156 181.914062 115.246094 182.257812 114.414062 C 182.601562 113.582031 182.859375 112.722656 183.035156 111.839844 C 183.210938 110.957031 183.296875 110.0625 183.296875 109.160156 C 183.296875 108.261719 183.210938 107.367188 183.035156 106.484375 C 182.859375 105.601562 182.601562 104.742188 182.257812 103.910156 C 181.914062 103.078125 181.492188 102.289062 180.992188 101.539062 C 180.492188 100.789062 179.925781 100.09375 179.292969 99.457031 C 178.65625 98.820312 177.964844 98.253906 177.21875 97.75 C 176.472656 97.25 175.683594 96.828125 174.855469 96.484375 C 174.023438 96.140625 173.167969 95.878906 172.289062 95.703125 C 171.40625 95.527344 170.519531 95.4375 169.621094 95.4375 C 168.722656 95.4375 167.832031 95.527344 166.953125 95.703125 C 166.070312 95.878906 165.214844 96.140625 164.386719 96.484375 C 163.554688 96.828125 162.765625 97.25 162.019531 97.75 C 161.273438 98.253906 160.582031 98.820312 159.949219 99.457031 C 159.3125 100.09375 158.746094 100.789062 158.246094 101.539062 C 157.746094 102.289062 157.328125 103.078125 156.984375 103.910156 C 156.640625 104.742188 156.378906 105.601562 156.203125 106.484375 C 156.027344 107.367188 155.941406 108.261719 155.941406 109.160156 C 155.941406 110.0625 156.03125 110.953125 156.207031 111.839844 C 156.382812 112.722656 156.640625 113.578125 156.988281 114.410156 C 157.332031 115.242188 157.753906 116.035156 158.25 116.78125 C 158.75 117.53125 159.316406 118.222656 159.953125 118.859375 C 160.585938 119.5 161.277344 120.066406 162.023438 120.566406 C 162.769531 121.066406 163.558594 121.492188 164.386719 121.835938 C 165.21875 122.179688 166.070312 122.441406 166.953125 122.617188 C 167.832031 122.796875 168.722656 122.882812 169.621094 122.886719 Z M 169.621094 101.042969 C 170.152344 101.042969 170.675781 101.09375 171.199219 101.199219 C 171.71875 101.300781 172.226562 101.457031 172.714844 101.660156 C 173.207031 101.863281 173.671875 102.117188 174.117188 102.410156 C 174.558594 102.707031 174.964844 103.042969 175.339844 103.421875 C 175.71875 103.796875 176.054688 104.207031 176.347656 104.652344 C 176.644531 105.09375 176.890625 105.5625 177.09375 106.054688 C 177.300781 106.546875 177.453125 107.054688 177.554688 107.578125 C 177.660156 108.101562 177.710938 108.628906 177.710938 109.164062 C 177.710938 109.695312 177.660156 110.222656 177.554688 110.746094 C 177.453125 111.269531 177.296875 111.777344 177.09375 112.269531 C 176.890625 112.761719 176.640625 113.230469 176.347656 113.675781 C 176.050781 114.117188 175.714844 114.527344 175.339844 114.902344 C 174.964844 115.28125 174.554688 115.617188 174.113281 115.914062 C 173.671875 116.210938 173.207031 116.460938 172.714844 116.664062 C 172.222656 116.867188 171.71875 117.023438 171.195312 117.125 C 170.675781 117.230469 170.148438 117.28125 169.617188 117.28125 C 169.085938 117.28125 168.558594 117.230469 168.039062 117.125 C 167.515625 117.023438 167.011719 116.867188 166.519531 116.664062 C 166.03125 116.460938 165.5625 116.210938 165.121094 115.914062 C 164.679688 115.617188 164.269531 115.28125 163.894531 114.902344 C 163.519531 114.527344 163.183594 114.117188 162.886719 113.671875 C 162.59375 113.230469 162.34375 112.761719 162.140625 112.269531 C 161.9375 111.777344 161.785156 111.269531 161.679688 110.746094 C 161.574219 110.222656 161.523438 109.695312 161.523438 109.164062 C 161.523438 108.628906 161.578125 108.101562 161.679688 107.578125 C 161.785156 107.054688 161.9375 106.546875 162.144531 106.054688 C 162.347656 105.5625 162.597656 105.097656 162.890625 104.652344 C 163.1875 104.210938 163.523438 103.800781 163.898438 103.421875 C 164.273438 103.046875 164.683594 102.710938 165.125 102.414062 C 165.566406 102.117188 166.03125 101.867188 166.523438 101.664062 C 167.015625 101.457031 167.519531 101.304688 168.042969 101.199219 C 168.5625 101.09375 169.089844 101.042969 169.621094 101.042969 Z M 169.621094 101.042969 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#000000"
        d="M 205.207031 110.035156 C 204.734375 109.160156 204.074219 108.464844 203.230469 107.941406 C 202.386719 107.417969 201.46875 107.140625 200.480469 107.105469 C 199.554688 107.070312 198.671875 107.253906 197.832031 107.648438 C 196.996094 108.046875 196.296875 108.617188 195.734375 109.359375 L 174.867188 136.945312 L 169.320312 131.378906 C 169.035156 131.089844 168.71875 130.835938 168.378906 130.617188 C 168.035156 130.394531 167.675781 130.214844 167.292969 130.074219 C 166.910156 129.929688 166.519531 129.832031 166.117188 129.773438 C 165.714844 129.71875 165.3125 129.703125 164.90625 129.734375 C 164.5 129.761719 164.101562 129.835938 163.714844 129.953125 C 163.324219 130.066406 162.949219 130.222656 162.59375 130.417969 C 162.238281 130.617188 161.90625 130.847656 161.601562 131.117188 C 161.292969 131.382812 161.019531 131.679688 160.777344 132.007812 L 148.476562 148.605469 C 148.164062 149.03125 147.914062 149.488281 147.726562 149.980469 C 147.539062 150.472656 147.425781 150.984375 147.378906 151.507812 C 147.335938 152.035156 147.363281 152.554688 147.460938 153.074219 C 147.5625 153.589844 147.730469 154.085938 147.96875 154.554688 C 148.203125 155.023438 148.5 155.453125 148.855469 155.84375 C 149.210938 156.230469 149.613281 156.5625 150.0625 156.835938 C 150.511719 157.113281 150.988281 157.320312 151.492188 157.460938 C 152 157.605469 152.515625 157.675781 153.039062 157.671875 L 221.832031 157.636719 C 222.382812 157.636719 222.921875 157.554688 223.453125 157.398438 C 223.980469 157.238281 224.472656 157.007812 224.933594 156.703125 C 225.394531 156.402344 225.804688 156.039062 226.160156 155.613281 C 226.515625 155.191406 226.800781 154.726562 227.023438 154.21875 C 227.375 153.414062 227.53125 152.570312 227.488281 151.6875 C 227.449219 150.804688 227.210938 149.980469 226.785156 149.210938 Z M 152.9375 151.984375 C 152.941406 151.972656 152.949219 151.960938 152.957031 151.949219 L 165.375 135.34375 L 170.921875 140.910156 C 171.207031 141.199219 171.519531 141.453125 171.859375 141.671875 C 172.199219 141.890625 172.558594 142.074219 172.941406 142.214844 C 173.320312 142.355469 173.707031 142.457031 174.109375 142.515625 C 174.507812 142.574219 174.910156 142.589844 175.316406 142.5625 C 175.71875 142.535156 176.117188 142.460938 176.503906 142.347656 C 176.894531 142.234375 177.265625 142.082031 177.621094 141.886719 C 177.976562 141.695312 178.308594 141.464844 178.613281 141.199219 C 178.921875 140.933594 179.195312 140.640625 179.441406 140.316406 L 200.320312 112.746094 L 221.828125 152.039062 Z M 152.9375 151.984375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <g fill="#000000" fillOpacity="1">
        <g transform="translate(90.61033, 280.605822)">
          <g>
            <path d="M 48.4375 0 L 18.546875 -52.8125 C 19.128906 -47.6875 19.421875 -43.566406 19.421875 -40.453125 L 19.421875 0 L 6.671875 0 L 6.671875 -68.578125 L 23.078125 -68.578125 L 53.390625 -15.328125 C 52.804688 -20.234375 52.515625 -24.695312 52.515625 -28.71875 L 52.515625 -68.578125 L 65.28125 -68.578125 L 65.28125 0 Z M 48.4375 0 " />
          </g>
        </g>
        <g transform="translate(162.598603, 280.605822)">
          <g>
            <path d="M 21.03125 -57.484375 L 21.03125 -36.265625 L 56.125 -36.265625 L 56.125 -25.171875 L 21.03125 -25.171875 L 21.03125 0 L 6.671875 0 L 6.671875 -68.578125 L 57.25 -68.578125 L 57.25 -57.484375 Z M 21.03125 -57.484375 " />
          </g>
        </g>
        <g transform="translate(223.489291, 280.605822)">
          <g>
            <path d="M 37.625 -57.484375 L 37.625 0 L 23.265625 0 L 23.265625 -57.484375 L 1.125 -57.484375 L 1.125 -68.578125 L 59.828125 -68.578125 L 59.828125 -57.484375 Z M 37.625 -57.484375 " />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function SolLogo({
  style,
  size,
  fill = 'black',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg
      viewBox="0 0 397.7 311.7"
      fill={fill}
      style={style}
      width={size}
      height={size}>
      <Path
        d="M64.6,237.9c2.4-2.4,5.7-3.8,9.2-3.8h317.4c5.8,0,8.7,7,4.6,11.1l-62.7,62.7c-2.4,2.4-5.7,3.8-9.2,3.8H6.5
      c-5.8,0-8.7-7-4.6-11.1L64.6,237.9z"
      />
      <Path
        d="M64.6,3.8C67.1,1.4,70.4,0,73.8,0h317.4c5.8,0,8.7,7,4.6,11.1l-62.7,62.7c-2.4,2.4-5.7,3.8-9.2,3.8H6.5
      c-5.8,0-8.7-7-4.6-11.1L64.6,3.8z"
      />
      <Path
        d="M333.1,120.1c-2.4-2.4-5.7-3.8-9.2-3.8H6.5c-5.8,0-8.7,7-4.6,11.1l62.7,62.7c2.4,2.4,5.7,3.8,9.2,3.8h317.4
      c5.8,0,8.7-7,4.6-11.1L333.1,120.1z"
      />
    </Svg>
  )
}

export function CreatorToolRegularIcon({
  size,
  style,
  fill = 'white',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg height={size || '1em'} viewBox="0 0 512 512" fill={fill} style={style}>
      <Path d="M128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.4-32-32-32zM418.6 58.1C359.2 9.3 281.3-10 204.6 5 104.9 24.4 24.7 104.2 5.1 203.7c-16.7 84.2 8.1 168.3 67.8 230.6 47.3 49.4 109.7 77.8 167.9 77.8 8.8 0 17.5-.6 26.1-2 24.2-3.7 44.6-18.7 56.1-41.1 12.3-24 12.3-52.7.2-76.6-6.1-12-5.5-26.2 1.8-38 7-11.8 18.7-18.4 32-18.4h72.2c46.4 0 82.8-35.7 82.8-81.3-.2-76.4-34.3-148.1-93.4-196.6zM429.2 288H357c-29.9 0-57.2 15.4-73 41.3-16 26.1-17.3 57.8-3.6 84.9 5.1 10.1 5.1 22.7-.2 32.9-2.6 5-8.7 13.7-20.6 15.6-49.3 7.7-108.9-16.6-152-61.6-48.8-50.9-69-119.4-55.4-188 15.9-80.6 80.8-145.3 161.6-161 62.6-12.3 126.1 3.5 174.3 43.1 48.1 39.5 75.7 97.6 75.9 159.6 0 18.6-15.3 33.2-34.8 33.2zM160 128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.4-32-32-32zm96-32.1c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32c0-17.6-14.3-32-32-32zm96 32.1c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z" />
    </Svg>
  )
}

export function CreatorToolSolidIcon({
  size,
  style,
  fill = 'white',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg height={size || '1em'} viewBox="0 0 512 512" fill={fill} style={style}>
      <Path d="M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
    </Svg>
  )
}

export function TrophyIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1903_2401)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.0001 0.599609C4.90303 0.599609 3.82647 0.688877 2.77739 0.860632C2.55982 0.896252 2.4001 1.08425 2.4001 1.30472V1.53664C1.90413 1.63074 1.41489 1.74391 0.933184 1.87538C0.743024 1.92727 0.608773 2.09688 0.601931 2.29388C0.600711 2.32899 0.600098 2.36424 0.600098 2.39961C0.600098 3.95652 1.78597 5.23631 3.30391 5.38516C3.76553 5.90652 4.37673 6.2935 5.07103 6.47848C5.01333 6.95028 4.87145 7.39568 4.66088 7.79961H4.5001C4.00304 7.79961 3.6001 8.20255 3.6001 8.69961V10.1996H3.1501C2.73588 10.1996 2.4001 10.5354 2.4001 10.9496C2.4001 11.1981 2.60157 11.3996 2.8501 11.3996H9.1501C9.39863 11.3996 9.6001 11.1981 9.6001 10.9496C9.6001 10.5354 9.26431 10.1996 8.8501 10.1996H8.4001V8.69961C8.4001 8.20255 7.99715 7.79961 7.5001 7.79961H7.33932C7.12874 7.39568 6.98686 6.95028 6.92916 6.47848C7.62347 6.2935 8.23466 5.90652 8.69628 5.38516C10.2142 5.23631 11.4001 3.95652 11.4001 2.39961C11.4001 2.36423 11.3995 2.32898 11.3983 2.29388C11.3914 2.09688 11.2572 1.92727 11.067 1.87538C10.5853 1.74391 10.0961 1.63074 9.6001 1.53664V1.30472C9.6001 1.08425 9.44037 0.896252 9.2228 0.860632C8.17372 0.688877 7.09717 0.599609 6.0001 0.599609ZM1.51524 2.65307C1.80745 2.57946 2.10247 2.51288 2.4001 2.45351V2.99961C2.4001 3.4433 2.48052 3.86856 2.62754 4.26134C2.0285 3.94774 1.5995 3.35342 1.51524 2.65307ZM10.485 2.65307C10.4007 3.35342 9.97169 3.94774 9.37266 4.26134C9.51968 3.86856 9.6001 3.4433 9.6001 2.99961V2.45351C9.89773 2.51288 10.1927 2.57946 10.485 2.65307Z"
          fill="#452996"
        />
      </g>
      <defs>
        <clipPath id="clip0_1903_2401">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function LoadingIndicator() {
  return (
    <Svg
      id="L5"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      width={45}
      height={17}
      enable-background="new 0 0 0 0">
      <circle fill="#fff" stroke="none" cx="6" cy="50" r="15">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 15 ; 0 -15; 0 15"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill="#fff" stroke="none" cx="60" cy="50" r="15">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 10 ; 0 -10; 0 10"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill="#fff" stroke="none" cx="114" cy="50" r="15">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </Svg>
  )
}

export function AndroidShareIcon({
  style,
  size,
  strokeWidth = 2,
  color = 'white',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
  color?: string
}) {
  return (
    <Svg
      viewBox="0 0 24 24"
      width={size || 24}
      height={size || 24}
      strokeWidth={strokeWidth}
      style={style}
      fill={color}>
      <Path
        d="M12 12H12.01M12 6H12.01M12 18H12.01M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18ZM13 6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export function AppleShareIcon({
  style,
  size,
  strokeWidth = 1.5,
  color = 'white',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
  color?: string
}) {
  return (
    <Svg
      viewBox="0 0 50 50"
      width={size || 24}
      height={size || 24}
      strokeWidth={strokeWidth}
      style={style}
      fill={color}>
      <Path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z" />
      <Path d="M24 7h2v21h-2z" />
      <Path d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z" />
    </Svg>
  )
}

export function ExchangeArrowIcon({
  style,
  size,
  strokeWidth = 1,
  color = 'white',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
  color?: string
}) {
  return (
    <Svg
      viewBox="0 0 128 128"
      width={size || 24}
      height={size || 24}
      strokeWidth={strokeWidth}
      style={style}
      fill={color}>
      <Path d="M33.8 53.3 30 49.5 .1 79.7 30 109.9l3.8-3.8L10 82.3h63.2v-5.2H10l23.8-23.8zm94.1-5.1L97.8 18.1 94 21.9l23.8 23.8h-63v5.2h63L94.1 74.8l3.8 3.8L128 48.5v-.3h-.1z" />
    </Svg>
  )
}

export function IphoneIcon({
  style,
  size,
  strokeWidth = 1.5,
  color = 'white',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
  color?: string
}) {
  return (
    <Svg
      viewBox="0 0 64 64"
      width={size || 24}
      height={size || 24}
      strokeWidth={strokeWidth}
      style={style}
      fill={color}>
      <Path d="M43.38,3.5H20.63A4.13,4.13,0,0,0,16.5,7.63V56.38a4.13,4.13,0,0,0,4.13,4.12H43.38a4.13,4.13,0,0,0,4.12-4.12V7.63A4.13,4.13,0,0,0,43.38,3.5ZM39,4.5V5a1.25,1.25,0,0,1-1.25,1.25H26.25A1.25,1.25,0,0,1,25,5V4.5Zm7.5,51.88a3.12,3.12,0,0,1-3.12,3.12H20.63a3.13,3.13,0,0,1-3.13-3.12V7.63A3.13,3.13,0,0,1,20.63,4.5H24V5a2.25,2.25,0,0,0,2.25,2.25h11.5A2.25,2.25,0,0,0,40,5V4.5h3.38A3.13,3.13,0,0,1,46.5,7.63Z" />
      <Path d="M28.14,5.92h6a.51.51,0,0,0,.5-.5.5.5,0,0,0-.5-.5h-6a.5.5,0,0,0-.5.5A.5.5,0,0,0,28.14,5.92Z" />
      <Path d="M35.69,5.92h.17a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5h-.17a.5.5,0,0,0-.5.5A.51.51,0,0,0,35.69,5.92Z" />
    </Svg>
  )
}

export function GlobeIcon({
  style,
  size,
  strokeWidth = 1.5,
  color = 'white',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
  color?: string
}) {
  return (
    <Svg
      viewBox="0 0 6720 6720"
      width={size || 20}
      height={size || 20}
      strokeWidth={strokeWidth}
      style={style}
      fill={color}>
      <Path d="M3360 1124c485,0 935,155 1302,419 376,271 665,655 816,1104l0 0c12,37 -7,76 -44,88 -8,3 -16,4 -24,4l-4101 0c-39,0 -70,-31 -70,-70 0,-10 2,-19 6,-28 151,-446 439,-829 814,-1098 367,-264 816,-419 1302,-419zm1220 532c-343,-247 -765,-392 -1220,-392 -456,0 -877,145 -1220,392 -327,235 -583,562 -732,943l3904 0c-148,-381 -405,-708 -732,-943zm895 2422c-151,446 -439,829 -814,1098 -367,264 -816,419 -1302,419 -485,0 -935,-155 -1302,-419 -376,-271 -665,-655 -816,-1104l0 0c-12,-37 7,-76 44,-88 8,-3 16,-4 24,-4l4101 0c39,0 70,31 70,70 0,10 -2,19 -6,28zm-895 985c327,-235 583,-562 732,-943l-3904 0c148,381 405,708 732,943 343,247 765,392 1220,392 456,0 877,-145 1220,-392z" />
      <Path d="M5086 4778c-208,254 -471,461 -770,603 -290,138 -614,215 -956,215 -342,0 -666,-77 -956,-215 -301,-143 -565,-352 -774,-607l0 0c-24,-30 -20,-74 10,-98 7,-6 16,-10 24,-13 266,-108 543,-191 828,-247 282,-55 572,-84 868,-84 296,0 587,29 868,84 288,56 567,141 834,250l0 0c36,15 53,55 38,91 -3,9 -8,16 -15,22zm-830 477c253,-120 479,-290 663,-497 -231,-88 -471,-158 -719,-206 -272,-53 -554,-81 -841,-81 -288,0 -569,28 -841,81 -248,49 -488,118 -719,206 185,207 410,376 663,497 272,129 576,201 897,201 321,0 625,-72 897,-201z" />
      <Path d="M4920 1962c-185,-207 -410,-376 -663,-497 -272,-129 -576,-201 -897,-201 -321,0 -625,72 -897,201 -253,120 -479,290 -663,497 231,88 471,158 719,206 272,53 554,81 841,81 288,0 569,-28 841,-81 248,-49 488,-118 719,-206zm-604 -623c299,142 562,349 770,603 6,6 11,14 15,22 15,36 -3,76 -38,91l0 0c-268,109 -547,194 -834,250 -282,55 -572,84 -868,84 -296,0 -587,-29 -868,-84 -285,-56 -562,-139 -828,-247 -9,-3 -17,-7 -24,-13 -30,-24 -34,-68 -10,-98l0 0c209,-256 473,-464 774,-607 290,-138 614,-215 956,-215 342,0 666,77 956,215z" />
      <Path d="M3360 1124c272,0 520,161 721,434 198,271 350,654 429,1099l0 0c7,38 -19,74 -57,81 -4,1 -9,1 -13,1l-2161 0c-39,0 -70,-31 -70,-70 0,-5 1,-10 2,-15 79,-444 231,-825 428,-1095 200,-273 449,-434 721,-434zm608 517c-174,-237 -384,-377 -608,-377 -224,0 -434,140 -608,377 -174,237 -310,570 -388,959l1993 0c-78,-389 -215,-721 -388,-959zm541 2425c-79,443 -231,825 -428,1095 -200,273 -449,434 -721,434 -272,0 -520,-161 -721,-434 -198,-271 -350,-654 -429,-1099l0 0c-7,-38 19,-74 57,-81 4,-1 9,-1 13,-1l2161 0c39,0 70,31 70,70 0,5 -1,10 -2,15zm-541 1013c174,-237 310,-570 388,-959l-1993 0c78,389 215,721 388,959 174,237 384,377 608,377 224,0 434,-140 608,-377z" />
      <Path d="M870 2599l4980 0 70 0 0 70 0 1381 0 70 -70 0 -4980 0 -70 0 0 -70 0 -1381 0 -70 70 0zm4911 140l-4841 0 0 1242 4841 0 0 -1242z" />
      <Path d="M1484 3766l-249 -812 142 0 129 469 48 174c2,-9 16,-65 42,-168l129 -476 142 0 122 471 41 155 46 -157 139 -470 134 0 -254 812 -143 0 -129 -487 -32 -139 -164 625 -144 0zm1567 0l-249 -812 142 0 129 469 48 174c2,-9 16,-65 42,-168l129 -476 142 0 122 471 41 155 46 -157 139 -470 134 0 -254 812 -143 0 -129 -487 -32 -139 -164 625 -144 0zm1567 0l-249 -812 142 0 129 469 48 174c2,-9 16,-65 42,-168l129 -476 142 0 122 471 41 155 46 -157 139 -470 134 0 -254 812 -143 0 -129 -487 -32 -139 -164 625 -144 0z" />
    </Svg>
  )
}

export function TipIcon({
  size,
  style,
  fill = '#ff8fab',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg
      width={size || 22}
      height={size || 22}
      fill={fill}
      style={style}
      viewBox="0 0 512 512">
      <Path d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z" />
    </Svg>
  )
}

export function MoneyBill({
  size,
  style,
  fill = '#71768A',
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg
      width={size || 22}
      height={size || 22}
      viewBox="0 0 576 512"
      fill={fill}
      style={style}>
      <path d="M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z" />
    </Svg>
  )
}

/**
 * Put all new Solarplex icons here.
 */

export function CommunitiesIcon({
  strokeWidth = 1.5,
  fill,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
  fill?: string
}) {
  return (
    <Svg
      height="1.3em"
      fill={fill}
      viewBox="0 0 640 512"
      strokeWidth={strokeWidth}>
      <Path d="M128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32C50.1 160 0 210.1 0 272c0 44.7 26.2 83.2 64 101.2V416c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H112l0-16V336l0-128h32c12.6 0 24.3 3.6 34.2 9.9c7.9-14.2 18.1-26.9 30.2-37.6C190.2 167.5 168 160 144 160H112zM64 229.7v84.7C54 303.1 48 288.2 48 272s6-31.1 16-42.3zM496 208h32V336v48 16H496V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V373.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H496c-24 0-46.2 7.5-64.4 20.3c12 10.7 22.3 23.4 30.2 37.6c9.9-6.3 21.6-9.9 34.2-9.9zm96 64c0 16.2-6 31.1-16 42.3V229.7c10 11.3 16 26.1 16 42.3zM560 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 32c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V389.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H304zm0 224V352 224h32l0 128v48 32H304V400zm-48-69.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3v84.7zm128 0V245.7c10 11.3 16 26.1 16 42.3s-6 31.1-16 42.3z" />
    </Svg>
  )
}

export function CommunitiesIconSolid({
  strokeWidth = 1.5,
  fill,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
  fill?: string
}) {
  return (
    <Svg
      height="1.3em"
      fill={fill}
      strokeWidth={strokeWidth}
      viewBox="0 0 640 512">
      <Path d="M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z" />
    </Svg>
  )
}

export function RegularFaceSmileIcon({
  size,
  style,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      width={size || 22}
      height={size || 22}
      viewBox="0 0 640 512"
      fill="#71768A"
      style={style}>
      <path d="M208 96C93.1 96 0 189.1 0 304s93.1 208 208 208 208-93.1 208-208S322.9 96 208 96zm0 368c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160-71.8 160-160 160zm61.8-124.2c-30.6 35.8-92.9 35.8-123.5 0-8.7-10.1-23.8-11.2-33.8-2.7-10.1 8.6-11.2 23.8-2.7 33.8 24.4 28.6 60.2 45 98.2 45s73.8-16.4 98.2-45c8.6-10.1 7.4-25.2-2.7-33.8-10-8.5-25.1-7.4-33.7 2.7zM144 288c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM624 88h-72V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v72h-72c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h72v72c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-72h72c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z" />
    </Svg>
  )
}

export function SolidFaceSmileIcon({
  size,
  style,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      width={size || 22}
      height={size || 22}
      viewBox="0 0 640 512"
      fill="#71768A"
      style={style}>
      <path d="M544 0c-13.3 0-24 10.7-24 24V72H472c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V120h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H568V24c0-13.3-10.7-24-24-24zM224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM140 346.1c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4z" />
    </Svg>
  )
}

export function SolidRankingStarIcon({
  size,
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg
      style={style}
      width={size || 22}
      height={size || 22}
      viewBox="0 0 640 512"
      fill={fill}
      stroke="currentColor">
      <Path d="M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z" />
    </Svg>
  )
}

export function RegularRankingStarIcon({
  size,
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg
      style={style}
      width={size || 22}
      height={size || 22}
      viewBox="0 0 640 512"
      fill={fill}
      stroke="currentColor">
      <Path d="M353.8 54.1l52.3 7.5c9.3 1.4 13.2 12.9 6.4 19.8l-38 36.6 9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.6-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l9-52.1-38-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5L309.8 6.3c4.3-8.6 16.5-8.3 20.4 0l23.6 47.8zM272 304V464h96V304H272zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V304zM48 368v96h96V368H48zM0 368c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368zm592 32H496v64h96V400zm-96-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z" />
    </Svg>
  )
}

export function SolidReactionIcon({
  size,
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg
      style={style}
      width={size || 22}
      height={size || 22}
      viewBox="0 0 512 512"
      stroke="currentColor"
      fill={fill}>
      <Path d="M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z" />
    </Svg>
  )
}

export function RegularReactionIcon({
  size,
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  fill?: string
}) {
  return (
    <Svg
      style={style}
      width={size || 22}
      height={size || 22}
      viewBox="0 0 512 512"
      stroke="currentColor"
      fill={fill}>
      <Path d="M144 343.78a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM101.74 213a37 37 0 0 0 52.36 0l78.56-78.44A79.06 79.06 0 0 0 227 17.49c-28.08-23.13-69.54-22.82-99-.86-29.45-22-71-22.3-99.05.89a79.11 79.11 0 0 0-5.77 117.08zM59.42 54.53A29.54 29.54 0 0 1 78.35 48 35.08 35.08 0 0 1 103 58.32l25 24.89 24.93-24.89c12.25-12.15 31.43-13.83 43.58-3.82a31.09 31.09 0 0 1 2.31 46.15l-70.85 70.71-70.87-70.69a31.13 31.13 0 0 1 2.32-46.14zm337.93 305.24l32.27-69.89a24 24 0 1 0-43.54-20.12l-63.7 138h109.27l-36.92 68.58A24 24 0 1 0 437 499.05l75-139.28zm-141.44-72h-27.42l-7.09-14.17a27.36 27.36 0 0 0-25.64-17.76H92.08a27.39 27.39 0 0 0-25.65 17.76l-7 14.21H32a32 32 0 0 0-32 32V480a32 32 0 0 0 32 32h223.91a32 32 0 0 0 32-32V319.79a32 32 0 0 0-32-31.98zm-16 176.23H48V335.79h41.22l13.21-26.73 2.57-5.26h77.83l2.69 5.4 13.24 26.59h41.13zm112-256V68.24L463.83 51v78.58a84 84 0 0 0-16-1.69c-35.34 0-64 21.47-64 48s28.64 48 64 48 64-21.48 64-48V32c0-17.9-13.54-32-29.64-32a28.08 28.08 0 0 0-4.26.33L329.39 23.17c-14.63 2.25-25.5 15.74-25.5 31.66V161.6a83.25 83.25 0 0 0-16-1.7c-35.33 0-64 21.55-64 48.13s28.64 48.13 64 48.13 63.98-21.55 63.98-48.16z" />
    </Svg>
  )
}

export function StarsIcon({
  fill = 'white',
}: {
  style?: StyleProp<ViewStyle>
  fill?: string
}) {
  return (
    <Svg width="22" height="22" fill={fill} viewBox="0 0 16 16">
      <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828l.645-1.937zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.734 1.734 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.734 1.734 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.734 1.734 0 0 0 3.407 2.31l.387-1.162zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L10.863.1z" />
    </Svg>
  )
}

export function CheckIcon() {
  return (
    <svg width="22" height="22" fill="#83b970" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
  )
}

export function GiftIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      viewBox="0 0 16 16"
      width={size || 20}
      height={size || 20}
      strokeWidth={strokeWidth}
      style={style}
      fill="#434248">
      <Path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zM1 4v2h6V4H1zm8 0v2h6V4H9zm5 3H9v8h4.5a.5.5 0 0 0 .5-.5V7zm-7 8V7H2v7.5a.5.5 0 0 0 .5.5H7z" />
    </Svg>
  )
}

export function GiftIconFilled({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      viewBox="0 0 16 16"
      width={size || 20}
      height={size || 20}
      strokeWidth={strokeWidth}
      style={style}
      fill="#434248">
      <Path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7h6zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9H2.5z" />
    </Svg>
  )
}

export function SolarplexCircleLogoDark({
  style,
  size = 48,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 260 260"
      style={style}
      fill="none">
      <Ellipse cx="130" cy="131" rx="130" ry="130.008" fill="#2E008B" />
      <Path
        d="M92.8573 255.624C72.3273 249.514 53.9226 238.468 39.019 223.863H92.8573V255.624Z"
        fill="#7173B9"
      />
      <Path
        d="M92.8569 223.863H167.096C177.357 223.863 185.668 215.551 185.668 205.29C185.668 195.029 177.357 186.718 167.096 186.718H111.428C101.168 186.718 92.8569 195.029 92.8569 205.29V223.863Z"
        fill="#397BAD"
      />
      <Path
        d="M12.5102 186.718C7.02529 175.171 3.19223 162.687 1.31641 149.573H92.857V168.145C92.857 178.406 84.5463 186.718 74.2856 186.718H12.5102Z"
        fill="#FEA39A"
      />
      <Path
        d="M111.428 112.427H204.286C214.546 112.427 222.857 120.739 222.857 131C222.857 141.261 214.546 149.573 204.286 149.573H92.8569V131C92.8569 120.739 101.168 112.427 111.428 112.427Z"
        fill="#FB7616"
      />
      <Path
        d="M1.31641 112.427C3.19224 99.3126 7.0253 86.8291 12.5102 75.2824H92.857V93.8549C92.857 104.116 84.5463 112.427 74.2856 112.427H1.31641Z"
        fill="#F8D55D"
      />
      <Path
        d="M92.8569 75.2824H167.096C177.357 75.2824 185.668 66.9712 185.668 56.7099C185.668 46.4485 177.357 38.1373 167.096 38.1373H111.428C101.168 38.1373 92.8569 46.4485 92.8569 56.7099V75.2824Z"
        fill="#FFB549"
      />
    </Svg>
  )
}

export function SolarplexCircleLogoLight({
  style,
  size = 48,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      width={size}
      height={size}
      style={style}
      viewBox="0 0 260 262"
      fill="none">
      <Ellipse cx="130" cy="131" rx="130" ry="130.008" fill="white" />
      <Path
        d="M92.8578 255.624C72.3278 249.514 53.9231 238.468 39.0195 223.863H92.8578V255.624Z"
        fill="#7173B9"
      />
      <Path
        d="M92.8574 223.863H167.097C177.357 223.863 185.668 215.552 185.668 205.29C185.668 195.029 177.357 186.718 167.097 186.718H111.429C101.168 186.718 92.8574 195.029 92.8574 205.29V223.863Z"
        fill="#397BAD"
      />
      <Path
        d="M12.5102 186.718C7.02529 175.171 3.19223 162.687 1.31641 149.573H92.857V168.145C92.857 178.406 84.5463 186.718 74.2856 186.718H12.5102Z"
        fill="#FEA39A"
      />
      <Path
        d="M111.429 112.427H204.286C214.547 112.427 222.857 120.739 222.857 131C222.857 141.261 214.547 149.573 204.286 149.573H92.8574V131C92.8574 120.739 101.168 112.427 111.429 112.427Z"
        fill="#FB7616"
      />
      <Path
        d="M1.31641 112.427C3.19224 99.3126 7.0253 86.8291 12.5102 75.2824H92.857V93.8549C92.857 104.116 84.5463 112.427 74.2856 112.427H1.31641Z"
        fill="#F8D55D"
      />
      <Path
        d="M92.8574 75.2824H167.097C177.357 75.2824 185.668 66.9712 185.668 56.7099C185.668 46.4485 177.357 38.1373 167.097 38.1373H111.429C101.168 38.1373 92.8574 46.4485 92.8574 56.7099V75.2824Z"
        fill="#FFB549"
      />
    </Svg>
  )
}

export function SolarplexLogoDark() {
  return (
    <svg width="150" height="25" viewBox="0 0 637 106" fill="none">
      <ellipse cx="42.889" cy="53.8916" rx="42.889" ry="42.8916" fill="white" />
      <path
        d="M30.6351 95.007C23.8619 92.9911 17.79 89.3469 12.873 84.5284H30.6351V95.007Z"
        fill="#7173B9"
      />
      <path
        d="M30.6357 84.5284H55.1284C58.5136 84.5284 61.2554 81.7864 61.2554 78.401C61.2554 75.0157 58.5136 72.2737 55.1284 72.2737H36.7627C33.3776 72.2737 30.6357 75.0157 30.6357 78.401V84.5284Z"
        fill="#397BAD"
      />
      <path
        d="M4.12757 72.2737C2.31802 68.4642 1.05344 64.3457 0.43457 60.0189H30.6352V66.1463C30.6352 69.5317 27.8934 72.2737 24.5082 72.2737H4.12757Z"
        fill="#FEA39A"
      />
      <path
        d="M36.7627 47.7643H67.3978C70.7829 47.7643 73.5248 50.5063 73.5248 53.8917C73.5248 57.277 70.7829 60.019 67.3978 60.019H30.6357V53.8917C30.6357 50.5063 33.3776 47.7643 36.7627 47.7643Z"
        fill="#FB7616"
      />
      <path
        d="M0.43457 47.7643C1.05344 43.4374 2.31802 39.3189 4.12757 35.5095H30.6352V41.6369C30.6352 45.0223 27.8934 47.7643 24.5082 47.7643H0.43457Z"
        fill="#F8D55D"
      />
      <path
        d="M30.6357 35.5095H55.1284C58.5136 35.5095 61.2554 32.7675 61.2554 29.3821C61.2554 25.9968 58.5136 23.2548 55.1284 23.2548H36.7627C33.3776 23.2548 30.6357 25.9968 30.6357 29.3821V35.5095Z"
        fill="#FFB549"
      />
      <path
        d="M122.092 81.2164C129.559 81.2164 134.339 77.9305 134.339 72.6534C134.339 68.6706 131.75 66.7787 125.676 65.2852L116.615 63.1942C106.957 61.0037 102.775 56.2244 102.775 49.2545C102.775 40.5919 109.546 34.5182 122.49 34.5182C138.222 34.5182 142.802 40.791 142.802 46.0682C142.802 48.5575 141.209 50.5489 137.724 50.5489C135.533 50.5489 133.642 49.354 133.642 47.1635V46.1678C133.642 42.5833 130.455 39.9945 123.187 39.9945C116.217 39.9945 112.433 43.1807 112.433 47.7609C112.433 51.1463 114.823 53.4364 120.2 54.6312L128.663 56.5231C139.915 59.0123 144.096 63.7916 144.096 71.2594C144.096 80.0215 137.127 86.6927 122.589 86.6927C106.758 86.6927 100.883 80.4198 100.883 73.8482C100.883 71.5581 102.476 69.4671 105.961 69.4671C108.052 69.4671 110.243 70.5624 110.243 72.9521V73.9478C110.243 78.2293 113.728 81.2164 122.092 81.2164ZM177.723 34.5182C192.758 34.5182 202.615 45.1721 202.615 60.5058C202.615 75.8396 192.758 86.4935 177.723 86.4935C162.588 86.4935 152.731 75.8396 152.731 60.6054C152.731 45.1721 162.588 34.5182 177.723 34.5182ZM177.723 80.1211C185.888 80.1211 191.265 75.043 191.265 67.874V53.4364C191.265 46.1678 185.888 40.8906 177.723 40.8906C169.359 40.8906 164.082 46.1678 164.082 53.4364V67.874C164.082 75.043 169.359 80.1211 177.723 80.1211ZM224.503 14.3055V85H214.148V20.8771H205.186V14.3055H224.503ZM269.71 78.528H269.112C265.926 83.2077 260.649 86.394 252.883 86.394C241.631 86.394 235.259 80.5194 235.259 71.5581C235.259 62.099 242.03 56.8218 253.779 56.8218C259.156 56.8218 263.736 57.917 268.316 59.6097V51.3454C268.316 44.0768 265.03 40.3928 256.865 40.3928C250.991 40.3928 247.605 42.882 247.605 46.8648V48.0596C247.605 50.748 245.913 52.2416 242.727 52.2416C239.64 52.2416 237.947 50.4493 237.947 47.1635C237.947 40.1936 244.618 34.5182 257.065 34.5182C271.9 34.5182 278.771 40.791 278.771 53.1377V71.7572C278.771 76.9349 280.264 78.7271 282.953 78.4284L287.533 78.0301V83.8052L273.792 85.7966C271.801 83.9047 270.506 81.5151 269.71 78.528ZM246.012 73.2508C246.012 77.4327 249.199 80.3202 255.571 80.3202C262.74 80.3202 268.316 76.3374 268.316 68.7701V64.2895C264.433 62.5968 260.35 61.6011 255.969 61.6011C249.398 61.6011 246.012 64.2895 246.012 68.8697V73.2508ZM294.694 85V42.6829H285.733V36.0117H305.049V44.4751H305.547C308.136 38.8992 313.314 34.7173 320.084 34.7173C327.652 34.7173 330.838 39.1979 330.838 45.5704C330.838 50.3497 328.548 53.0381 324.864 53.0381C322.175 53.0381 320.582 51.445 320.582 48.8562V45.9687C320.582 43.1807 319.089 41.9859 316.002 41.9859C310.028 41.9859 305.049 47.4622 305.049 56.2244V85H294.694ZM391.201 61.0037C391.201 78.0301 382.538 86.0953 370.291 86.0953C362.226 86.0953 357.347 82.4112 354.459 77.0344H353.961L353.862 105.213H343.507V42.6829H334.545V36.0117H353.862V43.7781H354.36C357.745 38.7001 362.724 35.016 370.291 35.016C382.638 35.016 391.201 43.4794 391.201 61.0037ZM353.862 64.6878C353.862 72.5538 358.243 78.9262 366.906 78.9262C374.971 78.9262 379.75 74.0473 379.75 65.783V55.2287C379.75 47.2631 374.871 42.185 367.005 42.185C361.429 42.185 357.546 44.8734 353.862 49.7523V64.6878ZM413.141 14.3055V85H402.786V20.8771H393.824V14.3055H413.141ZM470.794 75.043C466.214 82.7099 459.144 86.5931 449.685 86.5931C434.849 86.5931 424.992 76.5366 424.992 60.705C424.992 44.973 434.65 34.5182 449.785 34.5182C465.119 34.5182 475.076 45.2717 472.686 62.9951H436.343V67.5753C436.343 75.8396 442.516 80.3202 450.283 80.3202C457.153 80.3202 461.833 77.4327 465.318 71.8568L470.794 75.043ZM449.984 40.9902C441.819 40.9902 436.343 45.7695 436.343 53.536V57.7179H459.742C462.032 57.7179 463.227 56.3239 463.227 53.0381C463.227 45.8691 458.447 40.9902 449.984 40.9902ZM477.124 36.0117H502.116V42.6829H495.146L505.999 57.0209H506.596L517.649 42.6829H510.778V36.0117H529.398V42.6829H524.917L510.878 60.705L524.917 78.3288H530.394V85H505.7V78.3288H512.67L500.921 63.4929H500.423L488.973 78.3288H495.843V85H477.124V78.3288H481.604L496.042 59.8089L482.6 42.6829H477.124V36.0117Z"
        fill="white"
      />
    </svg>
  )
}

export function SolarplexLogo() {
  return (
    <svg
      width="150"
      height="25"
      viewBox="0 0 637 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <ellipse
        cx="42.889"
        cy="53.8916"
        rx="42.889"
        ry="42.8916"
        fill="#2E008B"
      />
      <path
        d="M30.6351 95.007C23.8619 92.9911 17.7899 89.3469 12.873 84.5284H30.6351V95.007Z"
        fill="#7173B9"
      />
      <path
        d="M30.635 84.5284H55.1277C58.5129 84.5284 61.2547 81.7864 61.2547 78.401C61.2547 75.0157 58.5129 72.2737 55.1277 72.2737H36.762C33.3768 72.2737 30.635 75.0157 30.635 78.401V84.5284Z"
        fill="#397BAD"
      />
      <path
        d="M4.12727 72.2737C2.31772 68.4642 1.05313 64.3457 0.434265 60.0189H30.6349V66.1463C30.6349 69.5317 27.8931 72.2737 24.5079 72.2737H4.12727Z"
        fill="#FEA39A"
      />
      <path
        d="M36.762 47.7643H67.397C70.7822 47.7643 73.524 50.5063 73.524 53.8917C73.524 57.277 70.7822 60.019 67.397 60.019H30.635V53.8917C30.635 50.5063 33.3768 47.7643 36.762 47.7643Z"
        fill="#FB7616"
      />
      <path
        d="M0.434265 47.7643C1.05313 43.4374 2.31772 39.3189 4.12727 35.5095H30.6349V41.6369C30.6349 45.0223 27.8931 47.7643 24.5079 47.7643H0.434265Z"
        fill="#F8D55D"
      />
      <path
        d="M30.635 35.5095H55.1277C58.5129 35.5095 61.2547 32.7675 61.2547 29.3821C61.2547 25.9968 58.5129 23.2548 55.1277 23.2548H36.762C33.3768 23.2548 30.635 25.9968 30.635 29.3821V35.5095Z"
        fill="#FFB549"
      />
      <path
        d="M122.092 81.2164C129.559 81.2164 134.339 77.9305 134.339 72.6534C134.339 68.6706 131.75 66.7787 125.676 65.2852L116.615 63.1942C106.957 61.0037 102.775 56.2244 102.775 49.2545C102.775 40.5919 109.546 34.5182 122.49 34.5182C138.222 34.5182 142.802 40.791 142.802 46.0682C142.802 48.5575 141.209 50.5489 137.724 50.5489C135.533 50.5489 133.642 49.354 133.642 47.1635V46.1678C133.642 42.5833 130.455 39.9945 123.187 39.9945C116.217 39.9945 112.433 43.1807 112.433 47.7609C112.433 51.1463 114.823 53.4364 120.2 54.6312L128.663 56.5231C139.915 59.0123 144.096 63.7916 144.096 71.2594C144.096 80.0215 137.127 86.6927 122.589 86.6927C106.758 86.6927 100.883 80.4198 100.883 73.8482C100.883 71.5581 102.476 69.4671 105.961 69.4671C108.052 69.4671 110.243 70.5624 110.243 72.9521V73.9478C110.243 78.2293 113.728 81.2164 122.092 81.2164ZM177.723 34.5182C192.758 34.5182 202.615 45.1721 202.615 60.5058C202.615 75.8396 192.758 86.4935 177.723 86.4935C162.588 86.4935 152.731 75.8396 152.731 60.6054C152.731 45.1721 162.588 34.5182 177.723 34.5182ZM177.723 80.1211C185.888 80.1211 191.265 75.043 191.265 67.874V53.4364C191.265 46.1678 185.888 40.8906 177.723 40.8906C169.359 40.8906 164.082 46.1678 164.082 53.4364V67.874C164.082 75.043 169.359 80.1211 177.723 80.1211ZM224.503 14.3055V85H214.148V20.8771H205.186V14.3055H224.503ZM269.71 78.528H269.112C265.926 83.2077 260.649 86.394 252.883 86.394C241.631 86.394 235.259 80.5194 235.259 71.5581C235.259 62.099 242.03 56.8218 253.779 56.8218C259.156 56.8218 263.736 57.917 268.316 59.6097V51.3454C268.316 44.0768 265.03 40.3928 256.865 40.3928C250.991 40.3928 247.605 42.882 247.605 46.8648V48.0596C247.605 50.748 245.913 52.2416 242.727 52.2416C239.64 52.2416 237.947 50.4493 237.947 47.1635C237.947 40.1936 244.618 34.5182 257.065 34.5182C271.9 34.5182 278.771 40.791 278.771 53.1377V71.7572C278.771 76.9349 280.264 78.7271 282.953 78.4284L287.533 78.0301V83.8052L273.792 85.7966C271.801 83.9047 270.506 81.5151 269.71 78.528ZM246.012 73.2508C246.012 77.4327 249.199 80.3202 255.571 80.3202C262.74 80.3202 268.316 76.3374 268.316 68.7701V64.2895C264.433 62.5968 260.35 61.6011 255.969 61.6011C249.398 61.6011 246.012 64.2895 246.012 68.8697V73.2508ZM294.694 85V42.6829H285.733V36.0117H305.049V44.4751H305.547C308.136 38.8992 313.314 34.7173 320.084 34.7173C327.652 34.7173 330.838 39.1979 330.838 45.5704C330.838 50.3497 328.548 53.0381 324.864 53.0381C322.175 53.0381 320.582 51.445 320.582 48.8562V45.9687C320.582 43.1807 319.089 41.9859 316.002 41.9859C310.028 41.9859 305.049 47.4622 305.049 56.2244V85H294.694ZM391.201 61.0037C391.201 78.0301 382.538 86.0953 370.291 86.0953C362.226 86.0953 357.347 82.4112 354.459 77.0344H353.961L353.862 105.213H343.507V42.6829H334.545V36.0117H353.862V43.7781H354.36C357.745 38.7001 362.724 35.016 370.291 35.016C382.638 35.016 391.201 43.4794 391.201 61.0037ZM353.862 64.6878C353.862 72.5538 358.243 78.9262 366.906 78.9262C374.971 78.9262 379.75 74.0473 379.75 65.783V55.2287C379.75 47.2631 374.871 42.185 367.005 42.185C361.429 42.185 357.546 44.8734 353.862 49.7523V64.6878ZM413.141 14.3055V85H402.786V20.8771H393.824V14.3055H413.141ZM470.794 75.043C466.214 82.7099 459.144 86.5931 449.685 86.5931C434.849 86.5931 424.992 76.5366 424.992 60.705C424.992 44.973 434.65 34.5182 449.785 34.5182C465.119 34.5182 475.076 45.2717 472.686 62.9951H436.343V67.5753C436.343 75.8396 442.516 80.3202 450.283 80.3202C457.153 80.3202 461.833 77.4327 465.318 71.8568L470.794 75.043ZM449.984 40.9902C441.819 40.9902 436.343 45.7695 436.343 53.536V57.7179H459.742C462.032 57.7179 463.227 56.3239 463.227 53.0381C463.227 45.8691 458.447 40.9902 449.984 40.9902ZM477.124 36.0117H502.116V42.6829H495.146L505.999 57.0209H506.596L517.649 42.6829H510.778V36.0117H529.398V42.6829H524.917L510.878 60.705L524.917 78.3288H530.394V85H505.7V78.3288H512.67L500.921 63.4929H500.423L488.973 78.3288H495.843V85H477.124V78.3288H481.604L496.042 59.8089L482.6 42.6829H477.124V36.0117Z"
        fill="#2E008B"
      />
      {/* <path
        d="M535.729 15.444H544.207V46.872H562.999V54H535.729V15.444ZM574.813 21.762H567.145V15.444H574.813V21.762ZM567.145 26.082H574.813V54H567.145V26.082ZM596.295 54H587.763L578.205 26.082H586.251L592.137 45.144H592.245L598.131 26.082H605.745L596.295 54ZM627.697 37.044C627.337 35.1 626.689 33.624 625.753 32.616C624.853 31.608 623.467 31.104 621.595 31.104C620.371 31.104 619.345 31.32 618.517 31.752C617.725 32.148 617.077 32.652 616.573 33.264C616.105 33.876 615.763 34.524 615.547 35.208C615.367 35.892 615.259 36.504 615.223 37.044H627.697ZM615.223 41.904C615.331 44.388 615.961 46.188 617.113 47.304C618.265 48.42 619.921 48.978 622.081 48.978C623.629 48.978 624.961 48.6 626.077 47.844C627.193 47.052 627.877 46.224 628.129 45.36H634.879C633.799 48.708 632.143 51.102 629.911 52.542C627.679 53.982 624.979 54.702 621.811 54.702C619.615 54.702 617.635 54.36 615.871 53.676C614.107 52.956 612.613 51.948 611.389 50.652C610.165 49.356 609.211 47.808 608.527 46.008C607.879 44.208 607.555 42.228 607.555 40.068C607.555 37.98 607.897 36.036 608.581 34.236C609.265 32.436 610.237 30.888 611.497 29.592C612.757 28.26 614.251 27.216 615.979 26.46C617.743 25.704 619.687 25.326 621.811 25.326C624.187 25.326 626.257 25.794 628.021 26.73C629.785 27.63 631.225 28.854 632.341 30.402C633.493 31.95 634.321 33.714 634.825 35.694C635.329 37.674 635.509 39.744 635.365 41.904H615.223Z"
        fill="#2E008B"

      /> */}
    </svg>
  )
}

/**
 * No new Solarplex Icons below this.
 */

export function GridIcon({
  style,
  solid,
}: {
  style?: StyleProp<ViewStyle>
  solid?: boolean
}) {
  const DIM = 4
  const ARC = 2
  return (
    <Svg width="24" height="24" style={style}>
      <Path
        d={`M4,1 h${DIM} a${ARC},${ARC} 0 0 1 ${ARC},${ARC} v${DIM} a${ARC},${ARC} 0 0 1 -${ARC},${ARC} h-${DIM} a${ARC},${ARC} 0 0 1 -${ARC},-${ARC} v-${DIM} a${ARC},${ARC} 0 0 1 ${ARC},-${ARC} z`}
        strokeWidth={2}
        stroke="#000"
        fill={solid ? '#000' : undefined}
      />
      <Path
        d={`M16,1 h${DIM} a${ARC},${ARC} 0 0 1 ${ARC},${ARC} v${DIM} a${ARC},${ARC} 0 0 1 -${ARC},${ARC} h-${DIM} a${ARC},${ARC} 0 0 1 -${ARC},-${ARC} v-${DIM} a${ARC},${ARC} 0 0 1 ${ARC},-${ARC} z`}
        strokeWidth={2}
        stroke="#000"
        fill={solid ? '#000' : undefined}
      />
      <Path
        d={`M4,13 h${DIM} a${ARC},${ARC} 0 0 1 ${ARC},${ARC} v${DIM} a${ARC},${ARC} 0 0 1 -${ARC},${ARC} h-${DIM} a${ARC},${ARC} 0 0 1 -${ARC},-${ARC} v-${DIM} a${ARC},${ARC} 0 0 1 ${ARC},-${ARC} z`}
        strokeWidth={2}
        stroke="#000"
        fill={solid ? '#000' : undefined}
      />
      <Path
        d={`M16,13 h${DIM} a${ARC},${ARC} 0 0 1 ${ARC},${ARC} v${DIM} a${ARC},${ARC} 0 0 1 -${ARC},${ARC} h-${DIM} a${ARC},${ARC} 0 0 1 -${ARC},-${ARC} v-${DIM} a${ARC},${ARC} 0 0 1 ${ARC},-${ARC} z`}
        strokeWidth={2}
        stroke="#000"
        fill={solid ? '#000' : undefined}
      />
    </Svg>
  )
}
export function GridIconSolid({style}: {style?: StyleProp<ViewStyle>}) {
  return <GridIcon style={style} solid />
}

export function HomeIcon({
  style,
  size,
  strokeWidth = 4,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      viewBox="0 0 48 48"
      width={size || 24}
      height={size || 24}
      stroke="currentColor"
      fill="none"
      style={style}>
      <Path
        strokeWidth={strokeWidth}
        d="M 23.951 2 C 23.631 2.011 23.323 2.124 23.072 2.322 L 8.859 13.52 C 7.055 14.941 6 17.114 6 19.41 L 6 38.5 C 6 39.864 7.136 41 8.5 41 L 18.5 41 C 19.864 41 21 39.864 21 38.5 L 21 28.5 C 21 28.205 21.205 28 21.5 28 L 26.5 28 C 26.795 28 27 28.205 27 28.5 L 27 38.5 C 27 39.864 28.136 41 29.5 41 L 39.5 41 C 40.864 41 42 39.864 42 38.5 L 42 19.41 C 42 17.114 40.945 14.941 39.141 13.52 L 24.928 2.322 C 24.65 2.103 24.304 1.989 23.951 2 Z"
      />
    </Svg>
  )
}

export function HomeIconSolid({
  style,
  size,
  strokeWidth = 4,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      viewBox="0 0 48 48"
      width={size || 24}
      height={size || 24}
      stroke="currentColor"
      style={style}>
      <Path
        fill="currentColor"
        strokeWidth={strokeWidth}
        d="m 23.951,2 c -0.32,0.011 -0.628,0.124 -0.879,0.322 L 8.859,13.52 C 7.055,14.941 6,17.114 6,19.41 V 38.5 C 6,39.864 7.136,41 8.5,41 h 8 c 1.364,0 2.5,-1.136 2.5,-2.5 v -12 C 19,26.205 19.205,26 19.5,26 h 9 c 0.295,0 0.5,0.205 0.5,0.5 v 12 c 0,1.364 1.136,2.5 2.5,2.5 h 8 C 40.864,41 42,39.864 42,38.5 V 19.41 c 0,-2.296 -1.055,-4.469 -2.859,-5.89 L 24.928,2.322 C 24.65,2.103 24.304,1.989 23.951,2 Z"
      />
    </Svg>
  )
}

// Copyright (c) 2020 Refactoring UI Inc.
// https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
export function MagnifyingGlassIcon({
  style,
  size,
  strokeWidth = 2,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
      />
    </Svg>
  )
}

export function MagnifyingGlassIcon2({
  style,
  size,
  strokeWidth = 2,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Ellipse cx="12" cy="11" rx="9" ry="9" />
      <Line x1="19" y1="17.3" x2="23.5" y2="21" strokeLinecap="round" />
    </Svg>
  )
}

export function MagnifyingGlassIcon2Solid({
  style,
  size,
  strokeWidth = 2,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Ellipse
        cx="12"
        cy="11"
        rx="7"
        ry="7"
        stroke="none"
        fill="currentColor"
      />
      <Ellipse cx="12" cy="11" rx="9" ry="9" />
      <Line x1="19" y1="17.3" x2="23.5" y2="21" strokeLinecap="round" />
    </Svg>
  )
}

// https://github.com/Remix-Design/RemixIcon/blob/master/License
export function BellIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 24}
      height={size || 24}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path d="M 11.642 2 H 12.442 A 8.6 8.55 0 0 1 21.042 10.55 V 18.1 A 1 1 0 0 1 20.042 19.1 H 4.042 A 1 1 0 0 1 3.042 18.1 V 10.55 A 8.6 8.55 0 0 1 11.642 2 Z" />
      <Line x1="9" y1="22" x2="15" y2="22" />
    </Svg>
  )
}

// https://github.com/Remix-Design/RemixIcon/blob/master/License
export function BellIconSolid({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      viewBox="0 0 24 24"
      width={size || 24}
      height={size || 24}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path
        d="M 11.642 2 H 12.442 A 8.6 8.55 0 0 1 21.042 10.55 V 18.1 A 1 1 0 0 1 20.042 19.1 H 4.042 A 1 1 0 0 1 3.042 18.1 V 10.55 A 8.6 8.55 0 0 1 11.642 2 Z"
        fill="currentColor"
      />
      <Line x1="9" y1="22" x2="15" y2="22" />
    </Svg>
  )
}

export function CogIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 32}
      height={size || 32}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
      />
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </Svg>
  )
}

export function CogIconSolid({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 32}
      height={size || 32}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 9.594 3.94 C 9.684 3.398 10.154 3 10.704 3 L 13.297 3 C 13.847 3 14.317 3.398 14.407 3.94 L 14.62 5.221 C 14.683 5.595 14.933 5.907 15.265 6.091 C 15.339 6.131 15.412 6.174 15.485 6.218 C 15.809 6.414 16.205 6.475 16.56 6.342 L 17.777 5.886 C 18.292 5.692 18.872 5.9 19.147 6.376 L 20.443 8.623 C 20.718 9.099 20.608 9.705 20.183 10.054 L 19.18 10.881 C 18.887 11.121 18.742 11.494 18.749 11.873 C 18.751 11.958 18.751 12.043 18.749 12.128 C 18.742 12.506 18.887 12.878 19.179 13.118 L 20.184 13.946 C 20.608 14.296 20.718 14.9 20.444 15.376 L 19.146 17.623 C 18.871 18.099 18.292 18.307 17.777 18.114 L 16.56 17.658 C 16.205 17.525 15.81 17.586 15.484 17.782 C 15.412 17.826 15.338 17.869 15.264 17.91 C 14.933 18.093 14.683 18.405 14.62 18.779 L 14.407 20.059 C 14.317 20.602 13.847 21 13.297 21 L 10.703 21 C 10.153 21 9.683 20.602 9.593 20.06 L 9.38 18.779 C 9.318 18.405 9.068 18.093 8.736 17.909 C 8.662 17.868 8.589 17.826 8.516 17.782 C 8.191 17.586 7.796 17.525 7.44 17.658 L 6.223 18.114 C 5.708 18.307 5.129 18.1 4.854 17.624 L 3.557 15.377 C 3.282 14.901 3.392 14.295 3.817 13.946 L 4.821 13.119 C 5.113 12.879 5.258 12.506 5.251 12.127 C 5.249 12.042 5.249 11.957 5.251 11.872 C 5.258 11.494 5.113 11.122 4.821 10.882 L 3.817 10.054 C 3.393 9.705 3.283 9.1 3.557 8.624 L 4.854 6.377 C 5.129 5.9 5.709 5.692 6.224 5.886 L 7.44 6.342 C 7.796 6.475 8.191 6.414 8.516 6.218 C 8.588 6.174 8.662 6.131 8.736 6.09 C 9.068 5.907 9.318 5.595 9.38 5.221 Z M 13.5 9.402 C 11.5 8.247 9 9.691 9 12 C 9 13.072 9.572 14.062 10.5 14.598 C 12.5 15.753 15 14.309 15 12 C 15 10.928 14.428 9.938 13.5 9.402 Z"
        fill="currentColor"
      />
    </Svg>
  )
}

// Copyright (c) 2020 Refactoring UI Inc.
// https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
export function MoonIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 32}
      height={size || 32}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
      />
    </Svg>
  )
}

// Copyright (c) 2020 Refactoring UI Inc.
// https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
export function SunIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 32}
      height={size || 32}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path
        d="M12 3V5.25M18.364 5.63604L16.773 7.22703M21 12H18.75M18.364 18.364L16.773 16.773M12 18.75V21M7.22703 16.773L5.63604 18.364M5.25 12H3M7.22703 7.22703L5.63604 5.63604M15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

// Copyright (c) 2020 Refactoring UI Inc.
// https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
export function UserIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 32}
      height={size || 32}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </Svg>
  )
}

export function UserIconSolid({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 32}
      height={size || 32}
      strokeWidth={strokeWidth}
      stroke="currentColor"
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
        d="M 15 9.75 C 15 12.059 12.5 13.503 10.5 12.348 C 9.572 11.812 9 10.822 9 9.75 C 9 7.441 11.5 5.997 13.5 7.152 C 14.428 7.688 15 8.678 15 9.75 Z"
      />
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
        d="M 17.982 18.725 C 16.565 16.849 14.35 15.748 12 15.75 C 9.65 15.748 7.435 16.849 6.018 18.725 M 17.981 18.725 C 16.335 20.193 14.206 21.003 12 21 C 9.794 21.003 7.664 20.193 6.018 18.725"
      />
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 17.981 18.725 C 23.158 14.12 21.409 5.639 14.833 3.458 C 8.257 1.277 1.786 7.033 3.185 13.818 C 3.576 15.716 4.57 17.437 6.018 18.725 M 17.981 18.725 C 16.335 20.193 14.206 21.003 12 21 C 9.794 21.003 7.664 20.193 6.018 18.725"
      />
    </Svg>
  )
}

// Copyright (c) 2020 Refactoring UI Inc.
// https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
export function UserGroupIcon({
  style,
  size,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      width={size || 32}
      height={size || 32}
      strokeWidth={2}
      stroke="currentColor"
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
      />
    </Svg>
  )
}

export function RepostIcon({
  style,
  size = 24,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth: number
}) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size} style={style}>
      <Path
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
        d="M 14.437 18.081 L 5.475 18.095 C 4.7 18.095 4.072 17.467 4.072 16.692 L 4.082 6.65 L 1.22 10.854 M 4.082 6.65 L 7.006 10.854 M 9.859 6.65 L 18.625 6.654 C 19.4 6.654 20.028 7.282 20.028 8.057 L 20.031 18.081 L 17.167 13.646 M 20.031 18.081 L 22.866 13.646"
      />
    </Svg>
  )
}

// Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
export function HeartIcon({
  style,
  size = 24,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth: number
}) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size} style={style}>
      <Path
        strokeWidth={strokeWidth}
        stroke="currentColor"
        fill="none"
        d="M 3.859 13.537 L 10.918 20.127 C 11.211 20.4 11.598 20.552 12 20.552 C 12.402 20.552 12.789 20.4 13.082 20.127 L 20.141 13.537 C 21.328 12.431 22 10.88 22 9.259 L 22 9.033 C 22 6.302 20.027 3.974 17.336 3.525 C 15.555 3.228 13.742 3.81 12.469 5.084 L 12 5.552 L 11.531 5.084 C 10.258 3.81 8.445 3.228 6.664 3.525 C 3.973 3.974 2 6.302 2 9.033 L 2 9.259 C 2 10.88 2.672 12.431 3.859 13.537 Z"
      />
    </Svg>
  )
}

// Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
export function HeartIconSolid({
  style,
  size = 24,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
}) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size} style={style}>
      <Path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1}
        d="M 3.859 13.537 L 10.918 20.127 C 11.211 20.4 11.598 20.552 12 20.552 C 12.402 20.552 12.789 20.4 13.082 20.127 L 20.141 13.537 C 21.328 12.431 22 10.88 22 9.259 L 22 9.033 C 22 6.302 20.027 3.974 17.336 3.525 C 15.555 3.228 13.742 3.81 12.469 5.084 L 12 5.552 L 11.531 5.084 C 10.258 3.81 8.445 3.228 6.664 3.525 C 3.973 3.974 2 6.302 2 9.033 L 2 9.259 C 2 10.88 2.672 12.431 3.859 13.537 Z"
      />
    </Svg>
  )
}

export function UpIcon({
  style,
  size,
  strokeWidth = 1.3,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
  strokeWidth: number
}) {
  return (
    <Svg
      viewBox="0 0 14 14"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        strokeWidth={strokeWidth}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 7 3 L 2 8 L 4.5 8 L 4.5 11.5 L 9.5 11.5 L 9.5 8 L 12 8 L 7 3 Z"
      />
    </Svg>
  )
}

export function UpIconSolid({
  style,
  size,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      viewBox="0 0 14 14"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        strokeWidth={1.3}
        stroke="currentColor"
        fill="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 7 3 L 2 8 L 4.5 8 L 4.5 11.5 L 9.5 11.5 L 9.5 8 L 12 8 L 7 3 Z"
      />
    </Svg>
  )
}

export function DownIcon({
  style,
  size,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      viewBox="0 0 14 14"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        strokeWidth={1.3}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 7 11.5 L 2 6.5 L 4.5 6.5 L 4.5 3 L 9.5 3 L 9.5 6.5 L 12 6.5 L 7 11.5 Z"
      />
    </Svg>
  )
}

export function DownIconSolid({
  style,
  size,
}: {
  style?: StyleProp<ViewStyle>
  size?: string | number
}) {
  return (
    <Svg
      viewBox="0 0 14 14"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        strokeWidth={1.3}
        stroke="currentColor"
        fill="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 7 11.5 L 2 6.5 L 4.5 6.5 L 4.5 3 L 9.5 3 L 9.5 6.5 L 12 6.5 L 7 11.5 Z"
      />
    </Svg>
  )
}

// Copyright (c) 2020 Refactoring UI Inc.
// https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
export function CommentBottomArrow({
  style,
  size,
  strokeWidth = 1.3,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  let color = 'currentColor'
  if (
    style &&
    typeof style === 'object' &&
    'color' in style &&
    typeof style.color === 'string'
  ) {
    color = style.color
  }
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth || 2.5}
      stroke={color}
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
      />
    </Svg>
  )
}

export function SquareIcon({
  style,
  size,
  strokeWidth = 1.3,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth || 1}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Rect x="6" y="6" width="12" height="12" strokeLinejoin="round" />
    </Svg>
  )
}

export function RectWideIcon({
  style,
  size,
  strokeWidth = 1.3,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth || 1}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Rect x="4" y="6" width="16" height="12" strokeLinejoin="round" />
    </Svg>
  )
}

export function RectTallIcon({
  style,
  size,
  strokeWidth = 1.3,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth || 1}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Rect x="6" y="4" width="12" height="16" strokeLinejoin="round" />
    </Svg>
  )
}

export function ComposeIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
      />
    </Svg>
  )
}

export function ComposeIcon2({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      viewBox="0 0 24 24"
      stroke="currentColor"
      fill="none"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Path
        d="M 20 9 L 20 16 C 20 18.209 18.209 20 16 20 L 8 20 C 5.791 20 4 18.209 4 16 L 4 8 C 4 5.791 5.791 4 8 4 L 15 4"
        strokeWidth={strokeWidth}
      />
      <Line
        strokeLinecap="round"
        x1="10"
        y1="14"
        x2="18.5"
        y2="5.5"
        strokeWidth={strokeWidth * 1.5}
      />
      <Line
        strokeLinecap="round"
        x1="20.5"
        y1="3.5"
        x2="21"
        y2="3"
        strokeWidth={strokeWidth * 1.5}
      />
    </Svg>
  )
}

export function SquarePlusIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      width={size || 24}
      height={size || 24}
      style={style}>
      <Line
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="12"
        y1="5.5"
        x2="12"
        y2="18.5"
        strokeWidth={strokeWidth * 1.5}
      />
      <Line
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="5.5"
        y1="12"
        x2="18.5"
        y2="12"
        strokeWidth={strokeWidth * 1.5}
      />
      <Rect
        strokeWidth={strokeWidth}
        x="4"
        y="4"
        width="16"
        height="16"
        rx="4"
        ry="4"
      />
    </Svg>
  )
}

export function InfoCircleIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
      stroke="currentColor"
      width={size}
      height={size}
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
      />
    </Svg>
  )
}

export function HandIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 76 76"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      fill="none"
      style={style}>
      <Path d="M33.5 37V11.5C33.5 8.46243 31.0376 6 28 6V6C24.9624 6 22.5 8.46243 22.5 11.5V48V48C22.5 48.5802 21.8139 48.8874 21.3811 48.501L13.2252 41.2189C10.72 38.9821 6.81945 39.4562 4.92296 42.228L4.77978 42.4372C3.17708 44.7796 3.50863 47.9385 5.56275 49.897L16.0965 59.9409C20.9825 64.5996 26.7533 68.231 33.0675 70.6201V70.6201C38.8234 72.798 45.1766 72.798 50.9325 70.6201L51.9256 70.2444C57.4044 68.1713 61.8038 63.9579 64.1113 58.5735V58.5735C65.6874 54.8962 66.5 50.937 66.5 46.9362V22.5C66.5 19.4624 64.0376 17 61 17V17C57.9624 17 55.5 19.4624 55.5 22.5V36.5" />
      <Path d="M55.5 37V11.5C55.5 8.46243 53.0376 6 50 6V6C46.9624 6 44.5 8.46243 44.5 11.5V37" />
      <Path d="M44.5 37V8.5C44.5 5.46243 42.0376 3 39 3V3C35.9624 3 33.5 5.46243 33.5 8.5V37" />
    </Svg>
  )
}

export function HashtagIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 30 30"
      strokeWidth={strokeWidth}
      width={size}
      height={size}
      style={style}>
      <Path d="M2 10H28" strokeLinecap="round" />
      <Path d="M2 20H28" strokeLinecap="round" />
      <Path d="M11 3L9 27" strokeLinecap="round" />
      <Path d="M21 3L19 27" strokeLinecap="round" />
    </Svg>
  )
}

// Copyright (c) 2020 Refactoring UI Inc.
// https://github.com/tailwindlabs/heroicons/blob/master/LICENSE
export function ShieldExclamation({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  let color = 'currentColor'
  if (
    style &&
    typeof style === 'object' &&
    'color' in style &&
    typeof style.color === 'string'
  ) {
    color = style.color
  }
  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth || 1.5}
      stroke={color}
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z"
      />
    </Svg>
  )
}

export function ListIcon({
  style,
  size,
  strokeWidth = 1.5,
}: {
  style?: StyleProp<TextStyle>
  size?: string | number
  strokeWidth?: number
}) {
  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth || 1.5}
      stroke="currentColor"
      width={size}
      height={size}
      style={style}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
      />
    </Svg>
  )
}
